<template>
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-button
        type="blue"
        :styleTextObj="{
          width: '44px',
          height: '24px',
          'line-height': '24px',
          padding: '0 8px',
          'min-width': '44px',
        }"
        @click="returnBack()"
        >返回</jd-button
      >
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div :class="{ formBox: localStepNum != 99 }">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <!-- <el-step title="活动模板"></el-step> -->
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 选中活动模板 -->
      <div class="firststep" v-if="localStepNum == 99">
        <div class="activeEdit_bottom">
          <div class="template">
            <div style="width: 82px; padding-top: 5px">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                v-for="(item, index) in tempSwitchList"
                @click="handleNav(item, index)"
                :key="item.id"
                :class="{ activeTem: index == tabActive }"
                v-show="item.isVisible"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div
                class="temImg_content"
                @click="handleOpen()"
                style="border: 1px solid #d4e2ff"
              >
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/dz.svg"
                      alt=""
                    />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div
                  class="temImg_content_wz"
                  style="background: #eaf1ff"
                ></div>
              </div>
              <!-- hover -->
              <div
                class="temImg_content_bgshadow"
                style="height: 432px; border-radius: 8px"
                @click="handleOpen()"
              >
                <div class="temImg_content_bgshadow_codeDZ">
                  <img
                    style="width: 100%"
                    src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div
              class="temImg"
              v-for="(item, index) in giftList"
              :key="item.id"
            >
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img
                    class="imgs"
                    style="width: 100%"
                    :src="item.imageUrl"
                    alt=""
                  />
                  <img
                    v-if="item.days"
                    class="temImg_content_img_free"
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/common/free.svg"
                    alt=""
                    srcset=""
                  />
                  <div v-if="item.days" class="temImg_content_img_time">
                    倒计时：{{ item.days }}
                  </div>
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.imageName }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div
                  class="temImg_content_bgshadow_code qrCodeIMG"
                  id="queryId"
                  ref="queryId"
                ></div>
                <div class="temImg_content_bgshadow_codeDesc">
                  手机扫码预览模板
                </div>
                <div
                  class="temImg_content_bgshadow_btn pointer"
                  @click="toCreated(index + 1, item.id)"
                >
                  使用此模板
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="secondstep" v-if="localStepNum == 0">
        <!-- <div style="margin-bottom: 10px">
          <jd-tip>
            说明<br />
            <template v-if="venderType">
              <p v-if="jdCrm.isCrm">
                1、云短信CRM：订购到期时间{{
                  jdCrm.endTime
                }}（自营店铺需要搭配<span
                  @click="toCRM"
                  class="pointer"
                  style="color: #fe4d45"
                  >云短信CRM</span
                >使用）
              </p>
              <p v-else>
                1、自营店铺需要搭配云短信CRM使用，<span
                  style="color: #fe4d45; cursor: pointer"
                  @click="toCRM"
                  >前往订购>></span
                >
              </p>
              <p>2、订单完成后发放奖励。</p>
            </template>
            <template v-else>
              <p>1、订单完成后发放奖励。</p>
            </template>
          </jd-tip>
        </div> -->

        <el-form
          :model="ruleForm"
          class="backgroundForm new-input-box"
          ref="ruleForm"
          label-width="130px"
        >
          <jd-title label="参与方式" type="bold"></jd-title>

          <el-form-item label="参与方式:" required>
            <div style="padding: 10px 0">
              <el-radio-group
                v-model="ruleForm.applyType"
                :disabled="activityData.isStart"
                @change="changeParticipateType"
              >
                <el-radio style="margin-bottom: 18px" :label="0"
                  >用户报名参与(消费者需要手动报名，报名成功后在活动时间段内支付的订单将计入统计，未报名不统计)</el-radio
                >
                <el-form-item v-if="ruleForm.applyType == 0">
                  <div style="border: 1px solid #f0f0f0; padding: 20px">
                    <div class="flex-column">
                      <el-checkbox
                        v-model="isSignLimitTime"
                        @change="
                          () => {
                            ruleForm.applyTimeStart = '';
                            ruleForm.applyTimeEnd = '';
                          }
                        "
                        :disabled="activityData.isStart"
                        >限制报名时间（不勾选则表示活动周期内都可报名）</el-checkbox
                      >
                      <div v-if="isSignLimitTime" class="greyBg-box">
                        <span class="mr-r-6">用户在</span>
                        <div class="my_select_time">
                          <el-date-picker
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="ruleForm.applyTimeStart"
                            placeholder="请输入报名时间"
                            class="picker"
                            size="small"
                            :disabled="activityData.isStart"
                            :clearable="false"
                            :picker-options="pickerOptionApply"
                            @change="applyTimeChange"
                            @focus="applyFocus"
                          ></el-date-picker>
                          <span class="time_to_text">至</span>
                          <el-date-picker
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="ruleForm.applyTimeEnd"
                            placeholder="请输入报名时间"
                            class="picker"
                            size="small"
                            :clearable="false"
                            :picker-options="pickerOptionApply"
                            default-time="['23:59:59']"
                            @change="applyTimeChange"
                            @focus="applyFocus"
                          ></el-date-picker>
                        </div>
                        <span style="margin: 0 8px">期间内报名</span>
                        <span v-if="activityData.isStart" style="color: #f56c6c"
                          >活动进行中仅支持修改结束时间</span
                        >
                      </div>

                      <el-checkbox
                        v-model="isSignLimitNum"
                        @change="ruleForm.applyLimitNum = ''"
                        :disabled="activityData.isStart"
                        >限制报名名额（不勾选则表示不限名额，最高可限制100000人）</el-checkbox
                      >
                      <div
                        v-if="isSignLimitNum"
                        class="greyBg-box"
                        style="margin-bottom: 0px"
                      >
                        <span class="mr-r-6">限制最多</span>
                        <el-input
                          v-model="ruleForm.applyLimitNum"
                          placeholder="请输入人数"
                          style="width: 100px"
                          @blur="applyLimitNumChange()"
                          @input="
                            ruleForm.applyLimitNum = getLimit(
                              $event,
                              1,
                              100000,
                              1
                            )
                          "
                          class="mr-r-6"
                        >
                        </el-input>
                        <span>人报名</span>
                        <span v-if="activityData.isStart" style="color: #f56c6c"
                          >活动进行中报名名额可增加不可减少</span
                        >
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <el-radio :label="1"
                  >免报名参与(消费者无需报名活动，活动期间内有新增订单且进入活动时自动判断消费者是否符合条件，符合则自动报名，免保名活动不支持配置参与条件)</el-radio
                >
              </el-radio-group>
            </div>
          </el-form-item>
          <informationForm
            v-model="ruleForm"
            needNonMember
            :localStepNum="localStepNum"
            :defaultActMember.sync="actMember"
            :peopleSelected.sync="peopleSelected"
            :plusObject.sync="ruleDto.plusObject"
            :isCheckOpenCardTime.sync="ruleDto.isCheckOpenCardTime"
            :openCardStartTime.sync="ruleDto.openCardStartTime"
            :openCardEndTime.sync="ruleDto.openCardEndTime"
            :disabled="activityData.isStart"
            @selectPeopleSure="selectPeopleSure"
            :isShowActivityTimeSlot="true"
            :activityId="activityData.id"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
            <template #activityTimeslot>
              <el-form-item label="活动时间:" required>
                <div class="my_select_time">
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="ruleForm.startTime"
                    type="datetime"
                    placeholder="开始日期"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 185px; font-size: 12px"
                    class="time1"
                    @change="activityTimeChange"
                    :picker-options="pickerOptionsValue"
                    :default-time="
                      $getDate(30)[0].substring(11, $getDate(30)[0].length)
                    "
                    :clearable="false"
                    :disabled="activityData.isStart"
                  >
                  </el-date-picker>
                  <div class="time_to_text" style="background: white">至</div>
                  <!-- :disabled="ruleForm.syncLastCycleEndTimeFlag" -->
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="ruleForm.endTime"
                    type="datetime"
                    placeholder="结束日期"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 200px; font-size: 12px"
                    class="time2"
                    @focus="orderFocus"
                    @change="activityTimeChange"
                    :picker-options="pickerOptionsValueEnd"
                    :default-time="
                      $getDate(30)[0].substring(11, $getDate(30)[0].length)
                    "
                    :clearable="false"     
                  >
                  </el-date-picker>
                  <i
                    class="el-icon-circle-close date_icon1"
                    v-if="!activityData.isStart"
                    @click="clearTime"
                  ></i>
                  <img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                    alt=""
                    class="date_icon2"
                  />
                </div>
                <el-checkbox
                  class="lastTime"
                  v-model="ruleForm.syncLastCycleEndTimeFlag"
                  @change="synchronizeChange"
                  >同步最后一个周期结束时间（请在周期设置中设置）</el-checkbox
                >
                <span class="lastTime" style="color: #666">
                  活动持续 <span style="color: #fe4d45">{{ timeDay }}</span> 天
                  <span style="color: #fe4d45">{{ timeOut }}</span> 小时
                  <span
                    v-if="
                      timeDay == 0 &&
                      timeOut == 0 &&
                      ruleForm.syncLastCycleEndTimeFlag
                    "
                    >（待同步时间）</span
                  >
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="活动时间不可超过互动数据授权有效期及店铺接入有效期"
                    placement="bottom"
                  >
                    <el-button type="text" style="width: 35px">
                      <i class="el-icon-question"></i>
                    </el-button>
                  </el-tooltip>
                </span>
              </el-form-item>
            </template>
          </informationForm>
          <!-- <jd-title label="基本信息" type="bold"></jd-title>
          <el-form-item label="活动名称:" required>
            <el-input
              v-model="ruleForm.activityName"
              maxlength="15"
              show-word-limit
              placeholder="请输入活动名称"
              style="width: 400px"
            ></el-input>
          </el-form-item>

          <el-form-item label="活动时间:" required>
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.startTime"
                type="datetime"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 185px; font-size: 12px"
                class="time1"
                @change="activityTimeChange"
                :picker-options="pickerOptionsValue"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :clearable="false"
                :disabled="activityData.isStart"
              >
              </el-date-picker>
              <div class="time_to_text" style="background: white;">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.endTime"
                type="datetime"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 200px; font-size: 12px"
                class="time2"
                @change="activityTimeChange"
                :picker-options="pickerOptionsValueEnd"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :clearable="false"
                :disabled="ruleForm.syncLastCycleEndTimeFlag"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                v-if="!activityData.isStart"
                @click="clearTime"
              ></i>
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
            <el-checkbox
              class="lastTime"
              v-model="ruleForm.syncLastCycleEndTimeFlag"
              @change="synchronizeChange"
              >同步最后一个周期结束时间（请在周期设置中设置）</el-checkbox
            >
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #fe4d45">{{ timeDay }}</span> 天
              <span style="color: #fe4d45">{{ timeOut }}</span> 小时
              <span
                v-if="
                  timeDay == 0 &&
                  timeOut == 0 &&
                  ruleForm.syncLastCycleEndTimeFlag
                "
                >（待同步时间）</span
              >
              <el-tooltip
                class="item"
                effect="light"
                content="活动时间不可超过互动数据授权有效期及店铺接入有效期"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
          </el-form-item>
          <el-form-item label="活动对象:" prop="partner">
            <el-radio
              v-model="actMember"
              label="1"
              :disabled="activityData.isStart"
              >不限</el-radio
            >
            <el-radio
              v-model="actMember"
              label="2"
              :disabled="activityData.isStart"
              >会员身份</el-radio
            >
            <el-radio
              v-model="actMember"
              label="3"
              :disabled="activityData.isStart || softType == 1"
              >指定人群
              <el-button
                style="margin-left: 10px"
                v-if="actMember == '3'"
                :disabled="activityData.isStart"
                @click="openCrowd"
                >已选人群({{ peopleSelected.length }})</el-button
              >
            </el-radio>

            <div v-if="actMember == '2'" style="display: flex">
              <span>会员等级：</span>
              <el-checkbox-group
                v-model="ruleForm.partner"
                @change="checkListchange"
                :disabled="activityData.isStart"
                v-if="actMember == '2'"
              >
                <el-checkbox label="-1" name="partner">全部</el-checkbox>
                <el-checkbox
                  label="0"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >非会员</el-checkbox
                >
                <el-checkbox
                  v-for="(item, index) in levelList"
                  :key="index"
                  :label="index + 1 + ''"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
            <div v-if="actMember == '2'" style="display: flex">
              <span>入会时间：</span>
              <el-checkbox
                v-model="ruleDto.isCheckOpenCardTime"
                :disabled="activityData.isStart"
                >指定时间段</el-checkbox
              >
              <div class="my_select_time" style="margin-left: 8px">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleDto.openCardStartTime"
                  type="datetime"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  :disabled="
                    !ruleDto.isCheckOpenCardTime || activityData.isStart
                  "
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleDto.openCardEndTime"
                  type="datetime"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px"
                  class="time2"
                  :picker-options="openCardEndTimeOptionsValue"
                  :clearable="false"
                  :disabled="
                    !ruleDto.isCheckOpenCardTime || activityData.isStart
                  "
                >
                </el-date-picker>
                <i
                  v-if="!activityData.isStart"
                  class="el-icon-circle-close date_icon1"
                  @click="clearNewTime"
                ></i>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
            </div>
            <span v-if="actMember == '2'" style="color: #f56c6c"
              >注意：该条件对【非会员】身份不生效</span
            >

            <span v-if="localStepNum == 3"
              >注：之前关注过店铺和未关注店铺的新粉丝可以参加活动，同一个活动只能参与一次</span
            >
          </el-form-item>

          <el-form-item label="Plus会员身份:" required>
            <el-radio
              v-model="ruleDto.plusObject"
              :label="0"
              :disabled="activityData.isStart"
              >不限</el-radio
            >
            <el-radio
              v-model="ruleDto.plusObject"
              :label="1"
              :disabled="activityData.isStart"
              >Plus会员</el-radio
            >
            <el-radio
              v-model="ruleDto.plusObject"
              :label="2"
              :disabled="activityData.isStart"
              >非plus会员</el-radio
            >
            <div style="color: #f56c6c">
              注意：使用该判断需满足“与京东PLUS团队有合作关系的商家”及“京东PLUS团队准许调用本接口的商家”，否则该条件不生效，保存活动后建议先自行测试无误后再投放。
            </div>
          </el-form-item>

          <el-form-item label="活动条件:">
            <el-checkbox
              label="关注店铺后方可参与活动"
              v-model="ruleForm.condFollow"
              :disabled="ruleForm.applyType == 1"
            ></el-checkbox>
          </el-form-item> -->

          <jd-title label="打卡模式" type="bold"></jd-title>

          <el-form-item label="打卡模式:" required>
            <el-radio-group
              v-model="ruleForm.checkInMode"
              :disabled="activityData.isStart"
            >
              <div style="margin: 10px 0 18px 0">
                <el-radio :label="0"
                  >按购物时间区分打卡周期（多个周期时间不可重叠，场景如下：10月设置消费达100元可打卡成功；11月设置消费达200元可打卡成功）</el-radio
                >
              </div>
              <div>
                <el-radio :label="1"
                  >按购物商品区分打卡周期（多个周期时间可重叠，场景如下：同一周期内可设置多个商品，如购买商品A--5次即可打卡成功，购买商品B-3次即可打卡成功）</el-radio
                >
              </div>
            </el-radio-group>
          </el-form-item>

          <jd-title label="订单累积规则" type="bold"></jd-title>
          <el-form-item label="订单状态:" required>
            <el-radio-group
              v-model="ruleForm.orderStatus"
              :disabled="activityData.isStart"
            >
              <el-radio :label="1">
                已完成
                <el-popover placement="top-start" width="300" trigger="hover">
                  <div>仅统计已完成的订单</div>
                  <span slot="reference" style="cursor: pointer; color: #7b61ff"
                    ><i
                      class="new-icon-box greyBg-right-word"
                      style="margin: -2px 5px"
                    ></i>
                  </span>
                </el-popover>
              </el-radio>
              <el-radio :label="2">
                已付款
                <el-popover placement="top-start" width="300" trigger="hover">
                  <div>下单付款后即可统计（预售商品需要支付尾款才统计）</div>
                  <span slot="reference" style="cursor: pointer; color: #7b61ff"
                    ><i
                      class="new-icon-box greyBg-right-word"
                      style="margin: -2px 5px"
                    ></i>
                  </span>
                </el-popover>
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <jd-title label="周期设置" type="bold"></jd-title>

          <el-form-item label="周期设置:" required>
            <div class="mr-bt-12">
              <jd-button
                type="blue"
                @click="openQuickConfig"
                :disabled="activityData.isStart"
                >快捷配置方案</jd-button
              >
              <jd-button
                type="blueText"
                @click="resetCycles"
                :disabled="activityData.isStart"
                >重置周期</jd-button
              >
            </div>
            <div style="max-width: 1270px">
              <el-collapse v-model="activeCollapse">
                <template>
                  <el-collapse-item
                    v-for="(item, it) in prizeSettingListLevel"
                    :key="it"
                    :name="it"
                    class="mb-20"
                    style="border: 1px solid #eeeeee"
                  >
                    <div slot="title" class="collapse-title">
                      <div class="collapse-title-content">周期{{ it + 1 }}</div>
                      <div>
                        <jd-button
                          v-if="
                            prizeSettingListLevel.length > 2 &&
                            !isCycleStart(item)
                          "
                          type="blueText"
                          @click.native.stop="delCycle(it)"
                          :disabled="backgroundOpacity"
                          >删除</jd-button
                        >
                        <jd-button
                          type="blueText"
                          @click.native.stop="copyCycle(item)"
                          :disabled="backgroundOpacity"
                          >复制</jd-button
                        >
                      </div>
                    </div>
                    <div>
                      <div class="rule-set-box" style="background: none">
                        <el-form-item label="周期名称:" required>
                          <el-input
                            maxlength="6"
                            v-model="item.cycleName"
                            show-word-limit
                            :disabled="isCycleEnd(item)"
                            placeholder="请输入周期名称"
                            class="w320"
                          >
                          </el-input>
                        </el-form-item>
                        <el-form-item label="周期时间:" required>
                          <div class="my_select_time">
                            <el-date-picker
                              type="datetime"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              v-model="item.cycleStartTime"
                              placeholder="选择日期时间"
                              class="picker"
                              size="small"
                              :disabled="isCycleStart(item)"
                              :clearable="false"
                              default-time="['00:00:00']"
                              :picker-options="pickerOptionsValue1"
                              @change="handleChangeCycleTime(item)"
                            ></el-date-picker>

                            <span class="time_to_text">至</span>
                            <el-date-picker
                              type="datetime"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              v-model="item.cycleEndTime"
                              placeholder="选择日期时间"
                              class="picker"
                              size="small"
                              :disabled="backgroundOpacity || isCycleEnd(item)"
                              :picker-options="pickerOptionsValue1"
                              :clearable="false"
                              default-time="['23:59:59']"
                              @change="handleChangeCycleTime(item)"
                            ></el-date-picker>
                          </div>
                          <div v-if="isRePeat" style="color: #f56c6c">
                            周期时间重复，请重新设置
                          </div>
                        </el-form-item>
                        <el-form-item label="下单店铺:" required>
                          <orderShopCom
                            :venderIds.sync="item.venderIds"
                            :multiShopGoods.sync="item.multiShopGoods"
                            :sellerSkuList.sync="item.sellerSkuList"
                            :isDisabled="isCycleStart(item)"
                            @changeShop="handleChangeShop($event,item)"
                          />
                        </el-form-item>
                        <el-form-item label="商品要求:" required>
                          <!-- <el-radio-group
                            v-model="item.orderWareType"
                            :disabled="isCycleStart(item)"
                            @input="handleChangeCycleOrder(item)"
                          >
                            <el-radio :label="0">全部商品</el-radio>
                            <el-radio :label="1">指定商品</el-radio>
                            <el-radio :label="2">排除商品</el-radio>
                          </el-radio-group>
                          <jd-button
                            :disabled="
                              item.orderWareType == 0 ||
                              isCycleStart(item)
                            "
                            style="width: 110px; margin-left: 10px"
                            @click="handleOpenCycleOrderWare(item)"
                          >
                            已选{{
                              item.orderWareList
                                ? item.orderWareList.length
                                : 0
                            }}个
                          </jd-button> -->
                          <productReqCom
                            :filterType.sync="item.orderWareType"
                            :venderIds.sync="item.venderIds"
                            :sellerSkuList.sync="item.sellerSkuList"
                            :multiShopGoods.sync="item.multiShopGoods"
                            :isCreated="isCreated"
                            :isDisabled="isCycleStart(item)"
                            :btnDisabled="isCycleStart(item)"
                            addGoodText="已选"
                          />
                          <div
                            v-if="ruleForm.checkInMode == 1"
                            style="color: #fe4d45"
                          >
                            购买任何商品均可打卡本周期，若多个周期时间重叠，将造成1笔订单打卡多个周期，请谨慎选择
                          </div>
                        </el-form-item>
                        <el-form-item label="金额统计类型:" required>
                          <el-radio-group
                            v-model="item.orderPaymentType"
                            :disabled="isCycleStart(item)"
                          >
                            <el-radio :label="1">
                              <span>订单金额（后台价）</span>
                              <el-tooltip class="item" effect="dark" content="是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                                <div class="new-icon-box" style="margin: -3px 8px"></div>
                              </el-tooltip>
                            </el-radio>
                            <el-radio :label="0" v-if="!isReVenderType(item)">
                              <span>用户应付金额</span>
                              <el-tooltip class="item" effect="dark" content="订单商品原价总额-订单优惠总额+订单运费+税费+调整运费金额=用户应付金额" placement="top-start">
                                <div class="new-icon-box" style="margin: -3px 8px"></div>
                              </el-tooltip>
                            </el-radio>
                            <el-radio :label="2" v-if="!isReVenderType(item)">
                              <span>用户实付金额</span>
                              <el-tooltip class="item" effect="dark" content="用户应付金额-支付优惠总额=用户实付金额" placement="top-start">
                                <div class="new-icon-box" style="margin: -3px 8px"></div>
                              </el-tooltip>
                            </el-radio>
                          </el-radio-group>
                          <div style="color: #f56c6c">
                            注意：由于接口原因，自营仅支持统计订单金额，pop可按需选择统计实付金额或订单金额。
                          </div>
                        </el-form-item>
                        <el-form-item label="指定商品规则:" v-if="item.orderPaymentType==1&&item.orderWareType == 1">
                          <el-select style="width: 280px;" v-model="item.filterSkuType" :disabled="activityData.isStart" placeholder="">
                            <el-option label="只要订单包含指定商品就整单计算" :value="0"></el-option>
                            <el-option label="仅统计订单内指定商品的金额和件数" :value="1"></el-option>
                          </el-select>
                          <jd-button type="blueText" class="ml12" @click="viewStatisticsLogic">查看统计逻辑</jd-button>
                        </el-form-item>
                        <el-form-item label="订单拆单后是否合并:" label-width="160px" required>
                          <el-radio-group
                            :disabled="activityData.isStart"
                            v-model="item.mergeOrder"
                          >
                            <el-radio :label="false">否</el-radio>
                            <el-radio :label="true">是</el-radio>
                          </el-radio-group>
                          <jd-button type="blueText" class="ml12" @click="viewMergeLogic">查看合并拆单逻辑</jd-button>
                        </el-form-item>
                        <el-form-item label="打卡达标条件:" required>
                          <el-radio-group
                            v-model="item.checkInConditionType"
                            :disabled="isCycleStart(item)"
                          >
                            <el-radio :label="0">单一条件</el-radio>
                            <el-radio :label="1">组合条件</el-radio>
                          </el-radio-group>
                          <div class="check-conditon-box">
                            <template v-if="item.checkInConditionType == 0">
                              <el-form-item>
                                <el-radio
                                  :label="0"
                                  v-model="item.singleConditionType"
                                  :disabled="isCycleStart(item)"
                                >
                                  <span class="mr-r-6">消费满</span>
                                  <el-input
                                    v-model="item.orderAmountThreshold"
                                    placeholder="请输入"
                                    style="width: 100px"
                                    :disabled="isCycleStart(item)"
                                    @input="
                                      item.orderAmountThreshold = getLimit(
                                        $event,
                                        1,
                                        999999,
                                        1
                                      )
                                    "
                                  ></el-input>
                                  <span class="margin-left-6">元</span>
                                </el-radio>
                              </el-form-item>
                              <el-form-item>
                                <el-radio
                                  :label="1"
                                  v-model="item.singleConditionType"
                                  :disabled="isCycleStart(item)"
                                >
                                  <span class="mr-r-6">消费满</span>
                                  <el-input
                                    v-model="item.itemNumThreshold"
                                    placeholder="请输入"
                                    style="width: 100px"
                                    :disabled="isCycleStart(item)"
                                    @input="
                                      item.itemNumThreshold = getLimit(
                                        $event,
                                        0,
                                        999999,
                                        1
                                      )
                                    "
                                  ></el-input>
                                  <span class="margin-left-6">件</span>
                                </el-radio>
                              </el-form-item>
                              <el-form-item>
                                <el-radio
                                  :label="2"
                                  v-model="item.singleConditionType"
                                  :disabled="isCycleStart(item)"
                                >
                                  <span class="mr-r-6">消费满</span>
                                  <el-input
                                    v-model="item.orderNumThreshold"
                                    placeholder="请输入"
                                    style="width: 100px"
                                    :disabled="isCycleStart(item)"
                                    @input="
                                      item.orderNumThreshold = getLimit(
                                        $event,
                                        0,
                                        999999,
                                        1
                                      )
                                    "
                                  ></el-input>
                                  <span class="margin-left-6">笔</span>
                                </el-radio>
                              </el-form-item>
                            </template>

                            <el-form-item v-if="item.checkInConditionType == 1">
                              <el-radio-group
                                v-model="item.combinationConditionMode"
                                :disabled="isCycleStart(item)"
                                class="mb-20"
                              >
                                <el-radio :label="0"
                                  >需满足全部条件才算达标</el-radio
                                >
                                <el-radio :label="1"
                                  >满足任一条件即算达标</el-radio
                                >
                              </el-radio-group>
                              <el-checkbox-group
                                v-model="item.combinationTypeCheck"
                                :disabled="isCycleStart(item)"
                              >
                                <el-form-item>
                                  <el-checkbox :label="0">
                                    <span class="mr-r-6">消费满</span>
                                    <el-input
                                      v-model="item.orderAmountThreshold"
                                      placeholder="请输入"
                                      style="width: 100px"
                                      :disabled="isCycleStart(item)"
                                      @input="
                                        item.orderAmountThreshold = getLimit(
                                          $event,
                                          1,
                                          999999,
                                          1
                                        )
                                      "
                                    ></el-input>
                                    <span class="margin-left-6">元</span>
                                  </el-checkbox>
                                </el-form-item>
                                <el-form-item>
                                  <el-checkbox :label="1">
                                    <span class="mr-r-6">消费满</span>
                                    <el-input
                                      v-model="item.itemNumThreshold"
                                      placeholder="请输入"
                                      style="width: 100px"
                                      :disabled="isCycleStart(item)"
                                      @input="
                                        item.itemNumThreshold = getLimit(
                                          $event,
                                          0,
                                          999999,
                                          1
                                        )
                                      "
                                    ></el-input>
                                    <span class="margin-left-6">件</span>
                                  </el-checkbox>
                                </el-form-item>
                                <el-form-item>
                                  <el-checkbox :label="2">
                                    <span class="mr-r-6">消费满</span>
                                    <el-input
                                      v-model="item.orderNumThreshold"
                                      placeholder="请输入"
                                      style="width: 100px"
                                      :disabled="isCycleStart(item)"
                                      @input="
                                        item.orderNumThreshold = getLimit(
                                          $event,
                                          0,
                                          999999,
                                          1
                                        )
                                      "
                                    ></el-input>
                                    <span class="margin-left-6">笔</span>
                                  </el-checkbox>
                                </el-form-item>
                              </el-checkbox-group>
                            </el-form-item>
                          </div>
                        </el-form-item>

                        <el-form-item label="奖品设置:" required>
                          <div style="max-width: 1100px">
                            <jd-button
                              type="blue"
                              v-if="
                                item.settingList.length < 10 &&
                                !backgroundOpacity &&
                                !isCycleStart(item)
                              "
                              @click="addSetting(item)"
                              class="mr-bt-12"
                              >添加奖品（{{
                                item.settingList.length
                              }}/10）</jd-button
                            >
                            <el-table
                              :data="item.settingList"
                              style="border: 1px solid #eeeeee"
                              :header-cell-style="{
                                background: '#fafafa',
                                'text-align': 'left',
                              }"
                              :key="tableKey"
                            >
                              <el-table-column label="奖品类型" align="center">
                                <template slot-scope="scope">
                                  {{ getPrizeTypeName(scope.row.prizeType) }}
                                  <!-- <span v-if="scope.row.prizeType == 1"
                                    >优惠券</span
                                  >
                                  <span v-if="scope.row.prizeType == 2"
                                    >京豆</span
                                  >
                                  <span v-if="scope.row.prizeType == 3"
                                    >实物</span
                                  >
                                  <span v-if="scope.row.prizeType == 4"
                                    >店铺积分</span
                                  >
                                  <span v-if="scope.row.prizeType == 5"
                                    >京东E卡</span
                                  >
                                  <span v-if="scope.row.prizeType == 6"
                                    >爱奇艺会员</span
                                  >
                                  <span v-if="scope.row.prizeType == 7"
                                    >京东PLUS会员</span
                                  >
                                  <span v-if="scope.row.prizeType == 8"
                                    >现金红包</span
                                  >
                                  <span v-if="scope.row.prizeType == 9"
                                    >谢谢参与</span
                                  >
                                  <span v-if="scope.row.prizeType == 10"
                                    >礼品卡</span
                                  >
                                  <span v-if="scope.row.prizeType == 12">{{
                                    venderType ? "令牌" : "专享价"
                                  }}</span> -->
                                </template>
                              </el-table-column>
                              <el-table-column
                                label="奖品价值"
                                width="100"
                                prop="price"
                                align="center"
                              ></el-table-column>
                              <el-table-column
                                label="奖品名称（15字内）"
                                width="270"
                              >
                                <template slot-scope="scope">
                                  <el-input
                                    v-model="scope.row.title"
                                    maxlength="15"
                                    :disabled="
                                      (isHavePrize(item, scope.$index) &&
                                        isCycleStart(item))
                                    "
                                    show-word-limit
                                    style="width: 230px"
                                    placeholder="请输入"
                                  ></el-input>
                                </template>
                              </el-table-column>
                              <el-table-column label="奖品数量" width="150">
                                <template slot-scope="scope">
                                  <el-input
                                    v-model="scope.row.totalAmount"
                                    @input.native="
                                      (e) =>
                                        (scope.row.totalAmount = checkputn(
                                          e,
                                          scope.row,
                                          'jindou'
                                        ))
                                    "
                                    @input="
                                      (scope.row.totalAmount = getNumberData(
                                        1,
                                        $event,
                                        0,
                                        1,
                                        999999
                                      )),
                                        prizeNum(scope.row)
                                    "
                                    style="width: 120px"
                                    placeholder="请输入"
                                    :disabled="
                                      isHavePrize(item, scope.$index) &&
                                      isCycleStart(item)
                                    "
                                  ></el-input>
                                </template>
                              </el-table-column>
                              <el-table-column
                                label="图片(202px*202px)"
                                width="150"
                              >
                                <template slot-scope="scope">
                                  <img
                                    v-if="scope.row.logo"
                                    :src="scope.row.logo"
                                    style="width: 50px; height: 50px"
                                    disabled
                                  />
                                </template>
                              </el-table-column>
                              <el-table-column label="每日发放限额" width="120">
                                <template slot-scope="scope">
                                  <dailyLimitConfig
                                    :row="scope.row"
                                    :backgroundOpacity="backgroundOpacity"
                                    :limitBtnDisabled="backgroundOpacity"
                                  ></dailyLimitConfig>
                                </template>
                              </el-table-column>
                              <el-table-column label="操作" min-width="180">
                                <template slot-scope="scope">
                                  <div class="flex-center">
                                    <jd-button
                                      type="blueText"
                                      :disabled="
                                        backgroundOpacity ||
                                        (isHavePrize(item, scope.$index) &&
                                          isCycleStart(item))
                                      "
                                      @click="centerVis2(scope, item)"
                                      >选择奖品</jd-button
                                    >
                                    <el-upload
                                      class="label-left"
                                      action="/jd-hd-web/image/upload"
                                      :show-file-list="false"
                                      :before-upload="beforeUpload"
                                      :on-success="
                                        (res) => handleUpload(res, scope.row)
                                      "
                                      :disabled="
                                        backgroundOpacity ||
                                        (isHavePrize(item, scope.$index) &&
                                          isCycleStart(item))
                                      "
                                    >
                                      <jd-button
                                        type="blueText"
                                        style="margin-right: 8px"
                                        :disabled="
                                          backgroundOpacity ||
                                          (isHavePrize(item, scope.$index) &&
                                            isCycleStart(item))
                                        "
                                        >上传图片</jd-button
                                      >
                                    </el-upload>
                                    <jd-button
                                      type="blueText"
                                      v-if="
                                        isCycleStart(item) && !backgroundOpacity
                                      "
                                      :disabled="
                                        (isHavePrize(item, scope.$index) &&
                                          isCycleEnd(item)) ||
                                        (!isHavePrize(item, scope.$index) &&
                                          isCycleStart(item))
                                      "
                                      @click="itemAddNum(scope.row)"
                                      >增加库存</jd-button
                                    >
                                    <jd-button
                                      v-if="item.settingList.length > 1"
                                      type="blueText"
                                      :disabled="
                                        backgroundOpacity ||
                                        (isHavePrize(item, scope.$index) &&
                                          isCycleStart(item))
                                      "
                                      @click="itemDel(scope.$index, item)"
                                      >删除</jd-button
                                    >
                                  </div>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </el-form-item>
                      </div>
                    </div>
                  </el-collapse-item>
                </template>
              </el-collapse>
              <jd-button
                @click="addCycle"
                :disabled="
                  prizeSettingListLevel.length >= 12 || backgroundOpacity
                "
                type="blue"
                :styleTextObj="{
                  height: '50px',
                  width: '1270px',
                  'font-weight': 'bold',
                }"
                >添加周期（{{ prizeSettingListLevel.length }}/12）</jd-button
              >
            </div>
          </el-form-item>

          <el-form-item label="展示设置:">
            <el-checkbox v-model="ruleForm.hideUnStartedCycleDetailsFlag"
              >未开始的周期隐藏“奖励和打卡达标条件”</el-checkbox
            >
            <el-checkbox v-model="ruleForm.hidePrizeStockInCFlag"
              >不在C端展示奖品库存</el-checkbox
            >
          </el-form-item>
          <jd-title label="周期打卡结算设置" type="bold"></jd-title>
          <el-radio-group
            v-model="ruleForm.cycleSettlementMode"
            :disabled="activityData.isStart"
          >
            <el-form-item label="周期结算规则:">
              <el-radio style="margin-bottom: 18px" :label="0"
                >统计消费者整个活动周期内的订单
                <span class="active-tip label-left"
                  >比如设置11月和12月打卡礼，消费者可能在12月中旬中途才报名参与，系统可自动计入消费者12月的全部订单；但已结束周期——11月暂无法统计，C端将记录为“缺卡”</span
                >
              </el-radio>
              <el-radio style="margin-bottom: 18px" :label="1"
                >仅统计消费者参与后产生的订单
                <span class="active-tip label-left"
                  >比如设置11月和12月打卡礼，消费者可能在12月中旬中途才报名参与，系统只计入消费者12月中旬之后产生的订单</span
                >
              </el-radio>
            </el-form-item>
          </el-radio-group>
          <!-- 累计打卡设置 -->
          <jd-title label="累计打卡设置" type="bold"></jd-title>
          <el-form-item label="累计打卡奖励:">
            <div class="flexc-cen-x">
              <el-switch
                :active-value="1"
                :disabled="activityData.isStart"
                :inactive-value="0"
                v-model="ruleForm.cumulativeCheckInRewardEnabled"
              ></el-switch>
              <span class="margin-left-6"
                >开启后可设置累计打卡奖励，活动开始后不可关闭，消费者每完成1次周期任务视为打卡1次，累计打卡N次可获得奖励</span
              >
            </div>
          </el-form-item>
          <div v-if="ruleForm.cumulativeCheckInRewardEnabled == 1">
            <el-form-item label="奖励领取次数:">
              <el-radio-group v-model="ruleForm.cumulativeRewardClaimType">
                <el-radio :label="0">满足累计打卡要求后均可领取</el-radio>
                <el-radio :label="1">只可领取1次</el-radio>
              </el-radio-group>
              <span class="margin-left-6"
                >消费者活动期间只能领取1次，领取后，若后续累计打卡达标也无法继续领取</span
              >
            </el-form-item>
            <!-- 累计打卡阶梯 -->
            <el-form-item label="累计打卡阶梯:">
              <div>
                当前最大打卡阶梯次数：{{ prizeSettingListLevel.length }}
              </div>
              <div>
                <el-collapse v-model="activeStep">
                  <template>
                    <el-collapse-item
                      v-for="(item, it) in cumulativeTierList"
                      :key="it"
                      :name="it"
                      class="mb-20"
                      style="border: 1px solid #eeeeee"
                    >
                      <div slot="title" class="collapse-title">
                        <div class="collapse-title-content">
                          阶梯{{ it + 1 }}
                        </div>
                        <div>
                          <jd-button
                            v-if="cumulativeTierList.length > 1"
                            type="blueText"
                            @click.native.stop="delStepList(it)"
                            :disabled="backgroundOpacity"
                            >删除</jd-button
                          >
                        </div>
                      </div>
                      <div>
                        <div class="rule-set-box" style="background: none">
                          <el-form-item label="阶梯名称:" required>
                            <el-input
                              maxlength="6"
                              v-model="item.tierName"
                              show-word-limit
                              :disabled="
                                backgroundOpacity || activityData.isStart
                              "
                              placeholder="请输入阶梯名称"
                              class="w320"
                            >
                            </el-input>
                          </el-form-item>
                          <el-form-item label="达标条件:" required>
                            <div class="flexc-cen-x">
                              <div>累计完成</div>
                              <el-input
                                v-model="item.requiredCheckInCount"
                                show-word-limit
                                :disabled="
                                  backgroundOpacity || activityData.isStart
                                "
                                placeholder="请输入数量"
                                style="width: 110px; margin: 0 8px"
                                @input="
                                  item.requiredCheckInCount = getNumberData(
                                    1,
                                    $event,
                                    0,
                                    1,
                                    prizeSettingListLevel.length
                                  );
                                  item.requiredCheckInCount = checkStepValue(
                                    $event,
                                    it
                                  );
                                "
                              >
                              </el-input>
                              <div>个周期打卡</div>
                            </div>
                          </el-form-item>

                          <el-form-item label="奖品设置:" required>
                            <div style="max-width: 1100px">
                              <jd-button
                                type="blue"
                                v-if="item.prizeList.length <= 30"
                                :disabled="activityData.isStart"
                                @click="addStepPrize(item)"
                                class="mr-bt-12"
                                >添加奖品（{{
                                  item.prizeList.length
                                }}/30）</jd-button
                              >
                              <jd-table
                                :tableData="item.prizeList"
                                maxHeight="400"
                              >
                                <el-table-column label="奖品类型">
                                  <template slot-scope="scope">
                                    {{ getPrizeTypeName(scope.row.prizeType) }}
                                    <!-- <span v-if="scope.row.prizeType == 1"
                                      >优惠券</span
                                    >
                                    <span v-if="scope.row.prizeType == 2"
                                      >京豆</span
                                    >
                                    <span v-if="scope.row.prizeType == 3"
                                      >实物</span
                                    >
                                    <span v-if="scope.row.prizeType == 4"
                                      >店铺积分</span
                                    >
                                    <span v-if="scope.row.prizeType == 5"
                                      >京东E卡</span
                                    >
                                    <span v-if="scope.row.prizeType == 6"
                                      >爱奇艺会员</span
                                    >
                                    <span v-if="scope.row.prizeType == 7"
                                      >京东PLUS会员</span
                                    >
                                    <span v-if="scope.row.prizeType == 8"
                                      >现金红包</span
                                    >
                                    <span v-if="scope.row.prizeType == 9"
                                      >谢谢参与</span
                                    >
                                    <span v-if="scope.row.prizeType == 10"
                                      >礼品卡</span
                                    >
                                    <span v-if="scope.row.prizeType == 12">{{
                                      venderType ? "令牌" : "专享价"
                                    }}</span> -->
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="奖品价值"
                                  width="100"
                                  prop="price"
                                ></el-table-column>
                                <el-table-column label="图片" width="150">
                                  <template slot-scope="scope">
                                    <img
                                      v-if="scope.row.logo"
                                      :src="scope.row.logo"
                                      style="width: 50px; height: 50px"
                                    />
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="奖品名称（12字内）"
                                  width="270"
                                >
                                  <template slot-scope="scope">
                                    <el-input
                                      v-model="scope.row.title"
                                      maxlength="12"
                                      :disabled="
                                        backgroundOpacity
                                      "
                                      show-word-limit
                                      style="width: 230px"
                                      placeholder="请输入"
                                    ></el-input>
                                  </template>
                                </el-table-column>
                                <el-table-column label="奖品总数" width="150">
                                  <template slot-scope="scope">
                                    <el-input
                                      v-model="scope.row.totalAmount"
                                      @input.native="
                                        (e) =>
                                          (scope.row.totalAmount = checkputn(
                                            e,
                                            scope.row,
                                            'jindou'
                                          ))
                                      "
                                      @input="
                                        (scope.row.totalAmount = getNumberData(
                                          1,
                                          $event,
                                          0,
                                          1,
                                          999999
                                        )),
                                          prizeNum(scope.row)
                                      "
                                      style="width: 120px"
                                      placeholder="请输入数量"
                                      :disabled="
                                        activityData.isStart ||
                                        backgroundOpacity
                                      "
                                    ></el-input>
                                  </template>
                                </el-table-column>

                                <el-table-column label="操作" min-width="180">
                                  <template slot-scope="scope">
                                    <div class="flex-center">
                                      <jd-button
                                        type="blueText"
                                        :disabled="
                                          backgroundOpacity ||
                                          activityData.isStart
                                        "
                                        @click="selectStepPrize(scope, item)"
                                        >选择奖品</jd-button
                                      >
                                      <jd-button
                                        type="blueText"
                                        v-if="activityData.isStart"
                                        :disabled="backgroundOpacity"
                                        @click="itemAddNum(scope.row, it, scope.$index)"
                                        >增加库存</jd-button
                                      >
                                      <jd-button
                                        v-if="item.prizeList.length > 1"
                                        type="blueText"
                                        :disabled="
                                          backgroundOpacity ||
                                          activityData.isStart
                                        "
                                        @click="
                                          itemStepPrizeDel(scope.$index, item)
                                        "
                                        >删除</jd-button
                                      >
                                    </div>
                                  </template>
                                </el-table-column>
                              </jd-table>
                            </div>
                          </el-form-item>
                        </div>
                      </div>
                    </el-collapse-item>
                  </template>
                </el-collapse>
                <jd-button
                  @click="addStepList"
                  :disabled="
                    cumulativeTierList.length >= prizeSettingListLevel.length ||
                    backgroundOpacity
                  "
                  type="blue"
                  :styleTextObj="{
                    height: '50px',
                    width: '1270px',
                    'font-weight': 'bold',
                  }"
                  >添加阶梯（{{ cumulativeTierList.length }}/{{
                    prizeSettingListLevel.length
                  }}）</jd-button
                >
              </div>
            </el-form-item>
          </div>
          <activityPageSettings
            isShowShopName
            isShowMoreSet
            isShowShopNameByChannel
            v-model="customerPaperwork"
            defaultTitleKey="activityTheme"
            defaultDescKey="activityRemark"
            defaultTitleColorKey="textColor"
            previewKey="imageUrl"
            :widthNumber="750"
            :heightNumber="1740"
            :giftList="giftList"
            :templateId="templateId"
            :cusTemplateJSON.sync="ruleDto.cusTemplateJSON"
            downloadTemplateUrl="https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/shop-card-new.psd"
            designSpecificationsUrl="https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/shop-card-preview.png"
            @selectTemplate="templateId = giftList[$event].id"
          >
            <template #otherSetMiddle>
              <el-form-item label="打卡标题:">
                <el-input
                  class="input-w425"
                  v-model="customerPaperwork.checkInTitle"
                  size="small"
                  maxlength="10"
                  show-word-limit
                ></el-input>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="不填则C端不显示"
                  placement="bottom"
                >
                  <i class="el-icon-question label-left"></i>
                </el-tooltip>
              </el-form-item>
            </template>
          </activityPageSettings>
          <!-- <jd-title label="活动页设置" type="bold"></jd-title>
          <el-form-item label="活动主题:">
            <el-input
              class="input-w425"
              v-model="ruleForm.activityTheme"
              size="small"
              maxlength="10"
              show-word-limit
            ></el-input>
            <el-tooltip
              class="item"
              effect="light"
              content="不填则C端不显示"
              placement="bottom"
            >
              <i class="el-icon-question label-left"></i>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="活动说明:">
            <el-input
              class="input-w425"
              v-model="ruleForm.activityRemark"
              size="small"
              maxlength="25"
              show-word-limit
            ></el-input>
            <el-tooltip
              class="item"
              effect="light"
              content="不填则C端不显示"
              placement="bottom"
            >
              <i class="el-icon-question label-left"></i>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="打卡标题:">
            <el-input
              class="input-w425"
              v-model="ruleForm.checkInTitle"
              size="small"
              maxlength="10"
              show-word-limit
            ></el-input>
            <el-tooltip
              class="item"
              effect="light"
              content="不填则C端不显示"
              placement="bottom"
            >
              <i class="el-icon-question label-left"></i>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="主题文字颜色:">
            <div class="flex-center">
              <el-color-picker v-model="ruleForm.textColor"></el-color-picker>
              <jd-button type="blueText" class="label-left" @click="resetColor"
                >重置</jd-button
              >
            </div>
          </el-form-item> -->

          <jd-title label="添加提醒" type="bold"></jd-title>
          <el-form-item label="日历提醒:" class="zindexBox">
            <el-checkbox v-model="ruleForm.calendarRemindFlag" class="mr-r-6">
              添加日历提醒
            </el-checkbox>
            <span class="mr-r-6"
              >勾选后，活动未开始或周期未开始时可引导消费者添加日历提醒</span
            >
          </el-form-item>
          <exposureList
            v-model="itemListForFilter"
            :defaultExposureSwitch.sync="ruleForm.exposureSwitch"
            :isLimit="true"
            :limitNum="limitNum"
            :isEdit="isCreated" 
            :multiShopSkuType.sync="multiShopSkuType" 
            :multiShopGoods="multiShopGoods" 
            :skuBelongVenderId="skuBelongVenderId"
          />
          <!-- <jd-title label="曝光商品" type="bold"></jd-title>
          <el-form-item label="曝光商品:" class="zindexBox" style="z-index: 1">
            <el-checkbox
              v-model="ruleForm.exposureSwitch"
              @change="exposureSwitchChange"
            >
              是否添加曝光商品
            </el-checkbox>
            <jd-button
              :class="[
                { add_btn1: ruleForm.exposureSwitch },
                { 'global-view-btn': backgroundOpacity },
              ]"
              style="margin: 0 15px"
              @click="exposureProductsFiter"
              :disabled="ruleForm.exposureSwitch == false"
            >
              {{
                itemListForFilter.length != ""
                  ? "添加曝光商品" +
                    "(" +
                    itemListForFilter.length +
                    "/20" +
                    ")"
                  : "添加曝光商品"
              }}
            </jd-button>
            <el-radio-group
              v-model="ruleForm.radio"
              :disabled="ruleForm.exposureSwitch == false"
            >
              <el-radio :label="0">显示京东价</el-radio>
            </el-radio-group>
            <draggable
              v-if="itemListForFilter.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="
                margin-top: 10px;
                background: rgba(38, 112, 251, 0.06);
                padding: 10px;
              "
              filter=".unmover"
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in mainImagelist"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                >
                  <img
                    :src="item.logo"
                    width="120px"
                    height="120px"
                    style="display: inline-block"
                  />&nbsp;
                  <div class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                      @click.stop="delec(index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item> -->
          <template>
            <sharFrom v-model="ruleForm" :sharePic="sharePic" />
            <!-- <jd-title label="分享设置" type="bold"></jd-title>
            <el-form-item label="小程序分享标题:" required label-width="125">
              <el-input
                type="text"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleForm.shareTitle"
                :maxlength="28"
                @input="$forceUpdate()"
              ></el-input>
            </el-form-item>
            <el-form-item label="小程序分享简介:" required label-width="125">
              <el-input
                type="text"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleForm.shareIntroduce"
                :maxlength="28"
                @input="$forceUpdate()"
              ></el-input>
            </el-form-item>
            <el-form-item label="小程序分享图片:" required label-width="130">
              <div class="miniAppPic" style="margin-left: 16px">
                <div class="top">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="beforeUpload1"
                    :on-success="handleUpload1"
                  >
                    <jd-button type="blueText">自定义上传</jd-button>
                  </el-upload>
                  <jd-button
                    type="blueText"
                    style="margin-left: 20px"
                    @click="picUrlReset1"
                    >重置</jd-button
                  >
                </div>
                <div class="bottom">
                  <el-image
                    class="elImg"
                    :src="ruleForm.sharePic"
                    fit="contain"
                  >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-plus"></i>
                    </div>
                  </el-image>
                  <div class="tips1">
                    <p>建议上传尺寸：200px * 200px</p>
                    <p>图片大小：1MB以内</p>
                    <p>格式：jpg、png</p>
                  </div>
                </div>
              </div>
            </el-form-item> -->
          </template>
          <activityRules
            v-model="ruleForm.ruleDescription"
            :isForceRemind.sync="ruleDto.isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            :activityData="activityData"
            :valueRow="valueRow"
            @generateRule="generateRule"
          />
          <!-- <jd-title label="活动规则" type="bold"></jd-title>
          <el-form-item label="规则内容:" required>
            <div style="width: 500px; padding: 8px; position: relative">
              <el-input
                :maxlength="2000"
                type="textarea"
                class="textarea"
                style="width: 543px"
                resize="none"
                v-model="ruleForm.ruleDescription"
                show-word-limit
              >
              </el-input>
              <div style="margin-top: 16px">
                <jd-button type="blue" @click="generateRule"
                  >生成规则</jd-button
                >
              </div>
              <div class="rule-tip">
                <jd-tip color="gley">
                  提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                </jd-tip>
              </div>
            </div>
          </el-form-item> -->

          <!-- <div
            v-if="backgroundOpacity"
            class="backgroundOpacity"
            style="height: calc(100% - 45px)"
          ></div> -->
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum != 99">
      <jd-button
        style="margin-right: 8px"
        v-show="!itemId && backgroundOpacity"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存到草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button
          v-show="!itemId"
          v-if="isSave"
          type="blue"
          @click="resetForm"
          v-preventReClick
          >保存设置</jd-button
        >
      </template>
      <jd-button v-show="itemId" style="margin-right: 8px" @click="cancelEdit"
        >取消</jd-button
      >
      <jd-button v-show="itemId" type="blue">保存设置</jd-button>
    </div>
    <!-- 选择奖品弹窗 -->
    <selectProduct
      ref="selectProduct"
      v-if="showSelectProduct"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :typeDefault="typeDefault"
      :actType="53"
      :actEndTime="ruleForm.endTime"
      @choose-shop="getTheData"
    >
    </selectProduct>
    <!-- 选择累计打卡阶梯商品弹窗 -->
    <selectProduct
      ref="selectProduct1"
      v-if="showSelectProduct1"
      :echoDate="echoDate1"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :typeDefault="typeDefault"
      :actType="53"
      :actEndTime="ruleForm.endTime"
      @choose-shop="getTheData1"
    >
    </selectProduct>

    <!-- 保存并完成设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          >确 定</jd-button
        >
      </div>
    </el-dialog>

    <!-- 快捷配置弹窗 -->
    <quickConfigPop
      v-model="isShowQuickConfig"
      @input="(val) => (isShowQuickConfig = val)"
      :defaultStartTime="ruleForm.startTime"
      :ruleForm="ruleForm"
      :valueRow="valueRow"
      @comfirm="confirmQuickConfig"
      :JingdouCount="JingdouCount"
      :typeDefault="typeDefault"
      :venderType="venderType"
    />
    <!-- 周期-指定购买商品 -->
    <selectGoodsMonitor
      ref="selectGoCycle"
      :isShow="selectGoodsStateCycle"
      @close="handleCycleOrderWareClose"
      :selectGoods="itemListForCycle"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :isSku="true"
      isInteract
    ></selectGoodsMonitor>
    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilter"
      ref="selectGoFilter"
      :isShow="selectGoodsStateFilter"
      @close="selectGoodsCloseFilter"
      :selectGoods="selectGoodsFilterArr"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="true"
      :disabled="backgroundOpacity"
      isInteract
    ></selectGoodsMonitor>
    <!-- 选择人群弹窗 -->
    <selectPeople
      v-if="selectPeopleShow"
      :dialogVisible="selectPeopleShow"
      :peopleList="peopleList"
      @confim="selectPeopleSure"
      @close="selectPeopleShow = false"
    ></selectPeople>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
  </div>
</template>

<script>
import activityPageSettings from "./components/activityPageSettings.vue";
import informationForm from "./components/informationForm.vue";
import exposureList from "./components/exposureList.vue";
import sharFrom from "./components/sharFrom.vue";
import activityRules from "./components/activityRules.vue";
import selectPeople from "@/components/select-people-yunqi.vue";
import selectProduct from "./select_product_componentization.vue";
import draggable from "vuedraggable";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import addPrizeNum from "./components/add-prize-num.vue";
import QRCode from "qrcodejs2";
import {
  hdTaskTemplateGroup,
  sellerImage,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import { publicOpen } from "@/api/jhk/public";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import quickConfigPop from "./components/quick_config_pop.vue";
import {
  saveActivityCommon,
  getActivityDetailCommon,
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
const defaultTextColor = "#000000";
import orderShopCom from "@/views/interactiveMarketing/activity/components/multipleStoreSetting/orderShopCom.vue";
import productReqCom from "@/views/interactiveMarketing/activity/components/multipleStoreSetting/productReqCom.vue";
import { useValidateMultiShopGoods, useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
export default {
  components: {
    selectProduct,
    selectGoodsMonitor,
    draggable,
    selectPeople,
    addPrizeNum,
    quickConfigPop,
    activityPageSettings,
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    dailyLimitConfig,
    orderShopCom,
    productReqCom,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    isRePeat() {
      if (this.ruleForm.checkInMode == 0) {
        const sortedCycles = [...this.prizeSettingListLevel]
          .filter((c) => c.cycleStartTime && c.cycleEndTime)
          .sort(
            (a, b) => new Date(a.cycleStartTime) - new Date(b.cycleStartTime)
          );
        let isTrue = false;
        for (let i = 1; i < sortedCycles.length; i++) {
          const prevEnd = new Date(sortedCycles[i - 1].cycleEndTime);
          const currStart = new Date(sortedCycles[i].cycleStartTime);

          if (currStart < prevEnd) {
            isTrue = true;
          }
        }
        return isTrue;
      } else {
        return false;
      }
    },
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || "";
    },
    venderId() {
      return this.$store.getters.loginUserInfo.venderId;
    },
    multiShopGoods() {
      return this.prizeSettingListLevel&&this.prizeSettingListLevel.length>0 ? this.prizeSettingListLevel[0].multiShopGoods : []
    },
    isReVenderType() {
      return (row) => {
        return row.multiShopGoods.some((item) => item.venderType);
      };
    },
    isGray() {
      return this.$store.getters.loginUserInfo.isGray;
    }
  },
  watch: {
    localStepNum(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.getCodeIMG();
        });
      } else {
        this.buriedPoint(1, this.activityData.name, "互动管理", "互动活动");
      }
    },
    'ruleForm.endTime': {
      handler(newValue, oldVal) {
        if (!newValue) return;
        const now = new Date();
        const endTime = new Date(newValue);
        // 判断是否为当天
        const isSameDay = endTime.getFullYear() === now.getFullYear() &&
                         endTime.getMonth() === now.getMonth() &&
                         endTime.getDate() === now.getDate();
       if(!isSameDay){
         this.pickerOptionsValueEnd.selectableRange = `00:00:00 - 23:59:59`;
        } else {
             // 获取当前时间
            const now = new Date();
            
            // 计算当前时间一小时后
            const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000);
            const timeStr = oneHourLater.toTimeString().substring(0, 8);
            console.log(timeStr,'8578787');
            
            // 更新结束时间选择器的时分秒范围
            // 注意：由于Element UI的限制，这个更新可能不会立即生效
            // 需要用户重新打开日期选择器
            this.pickerOptionsValueEnd.selectableRange = `${timeStr} - 23:59:59`;
        }
      },
    }
  },
  data() {
    return {
      customerPaperwork: {
        checkInTitle: "",
        activityTheme: "购物打卡",
        activityRemark: "打卡瓜分限量好礼",
        checkInTitle: "打卡日历",
        textColor: defaultTextColor,
      },
      multiShopSkuType: 0,
      skuBelongVenderId: "",
      limitNum: 20,
      isCreated: false,
      nowSelectCycle: {},
      nowSelectStepPrize: {},
      cumulativeTierList: [],
      actEndTime: "",
      actMember: "1",
      selectPeopleShow: false,
      peopleList: [],
      peopleSelected: [],
      templateId: "",
      tabActive: 0,
      navItem: "",
      giftList: [],
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      itemArr: [],
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: -1,
        },
      ],
      showSelectProduct1: false,
      echoDate: {},
      echoDate1: {},
      includeArr: [], //指定商品
      excludeArr: [], //排除商品
      showSelectProduct: false,
      // 1.14迭代 指定入会时间
      ruleDto: {
        isCheckOpenCardTime: false,
        openCardStartTime: "",
        openCardEndTime: "",
        plusObject: 0, //plus会员
        cusTemplateJSON: "",
        isForceRemind: false,
      },
      isKeyActivity: 0,
      placementPosition: [],
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < new Date(this.ruleDto.openCardStartTime).valueOf()
          );
        },
      },
      pickerOptionsValue: {
        disabledDate: (time) => {
          if (this.ruleForm.endTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() > new Date(this.ruleForm.endTime).valueOf()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.startTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() < new Date(this.ruleForm.startTime).valueOf()- 8.64e7 
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        // 默认不限制时间范围
        selectableRange: "00:00:00 - 23:59:59",
      },
      JingdouCount: {
        prizeCount: 0,
      },

      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      qrcode: null,
      joinBlackList: false,
      checked: false,
      // winningRate: 0,
      localStepNum: 0, // 将外部传入的步骤赋值到本地，避免直接更改props
      mainImagelist: [], //图片拖拽排序
      itemListForFilter: [],
      selectGoodsFilterArr: [],
      selectGoodsStateFilter: false,
      getPrizeType: 1,
      ruleForm: {
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        openCardFollow: 1, // 开卡入会后方可参与活动
        radio: 0,
        exposureSwitch: false,
        activityName: "",
        startTime: null,
        endTime: null,
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],

        applyTimeStart: "",
        applyTimeEnd: "",
        applyLimitNum: "",
        syncLastCycleEndTimeFlag: true, // 同步最后一个周期的结束时间
        applyType: 0, //参与方式
        checkInMode: 0, // 打卡模式
        orderStatus: 1, // 订单累积状态
        hideUnStartedCycleDetailsFlag: false, // 展示设置
        hidePrizeStockInCFlag: false, // 不在C端展示奖品库存
        cycleSettlementMode: 0, // 周期结算规则
        calendarRemindFlag: false, // 日历提醒

        activityTheme: "购物打卡",
        activityRemark: "打卡瓜分限量好礼",
        checkInTitle: "打卡日历",
        textColor: defaultTextColor,

        shareTitle: "", // 分享标题
        shareIntroduce: "", // 分享简介
        sharePic: "", // 分享图片
        cumulativeCheckInRewardEnabled: 0,
        cumulativeRewardClaimType: 0,
        isValidBlackList: 0,
      },
      sharePic: "", // 初始图
      prizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
        },
      ],
      index: 0,
      theNum: 0,
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      fileList: "",
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      jdCrm: {
        startTime: "",
        endTime: "",
        isCrm: false,
      },
      templateJson: {
        templateUItype: "",
      },
      levelList: [],
      isDraft: false,
      toAddItem: null,
      cumulativePrizeIndex: null,
      cumulativeTierIndex: null,
      isShowAddNum: false,
      toAddBelong: "",
      toAddIndex: 0,
      isFirstTime: true,
      defaultLogo: "https://cdn-image.yucrm.cn/hd/images/prizeShow646.png",

      sort: 0, // 排序

      tableIndex: 0,
      tableIndex1: 0,
      itemListForCycle: [],
      selectGoodsStateCycle: false,
      isSignLimitTime: false, // 报名限制
      isSignLimitNum: false, // 报名限制时间
      applyTime: [], // 报名限制时间
      originApplyLimitNum: "", // 接口返回初始报名人数
      originCycleArr: [], // 接口返回初始周期数组

      activeCollapse: [0], // 折叠面板
      activeStep: [0],
      isShowQuickConfig: false, // 快捷配置

      prizeSettingListLevel: [],
      pickerOptionApply: {
        disabledDate: (time) => {
          let cycleList = this.prizeSettingListLevel;
          let lastTime =
            cycleList.length > 0
              ? cycleList[cycleList.length - 1].cycleEndTime
              : "";
          if (this.ruleForm.endTime && this.ruleForm.startTime) {
            return (
              time.getTime() > new Date(this.ruleForm.endTime).getTime() ||
              time.getTime() <
                new Date(this.ruleForm.startTime).getTime() -
                  24 * 60 * 60 * 1000
            );
          } else if (lastTime && this.ruleForm.startTime) {
            return (
              time.getTime() > new Date(lastTime).getTime() ||
              time.getTime() <
                new Date(this.ruleForm.startTime).getTime() -
                  24 * 60 * 60 * 1000
            );
          } else {
            return false;
          }
        },
      },
      pickerOptionsValue1: {
        disabledDate: (time) => {
          if (this.ruleForm.endTime && this.ruleForm.startTime) {
            return (
              time.getTime() > new Date(this.ruleForm.endTime).getTime() ||
              time.getTime() <
                new Date(this.ruleForm.startTime).getTime() -
                  24 * 60 * 60 * 1000
            );
          } else {
            return false;
          }
        },
      },
      tableKey: 0,
    };
  },
  created() {
    console.log("当前玩法id", this.activityData.id);
    this.sharePic = this.getDefaultSharePic(this.activityData.id);
    this.ruleForm.sharePic = this.sharePic;
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.getLevel();
    this.publicOpen();
    this.getDetail();
    this.hdTaskTemplateGroup();
    if (!this.valueRow && this.isFirstTime) {
      this.isFirstTime = false;
      this.setTime();
      this.activityTimeChange();
    }
  },

  methods: {
    viewMergeLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/mub1q6wafxefavp4?singleDoc#")
    },
    viewStatisticsLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/ribmlurbi01iznn8?singleDoc#")
    },
    handleChangeShop(val,item) {
      const hasVender = item.multiShopGoods.some((item) => item.venderType);
      const isPop = item.multiShopGoods.length > 0 && !hasVender;
      if (!isPop) {
        // 包含自营或混合，设置为订单金额
        item.orderPaymentType = 1;
      } 
      // else {
      //   // 包含自营或混合，设置为订单金额
      //   item.orderPaymentType = 1;
      // }
    },
    initData(isReset = false) {
      this.prizeSettingListLevel.forEach((item)=>{
        item.venderIds = !isReset&&item.venderIds.length>1 ? item.venderIds : [this.venderId];
        item.sellerSkuList = !isReset&&item.sellerSkuList.length>0 ? item.sellerSkuList : [
          {
            venderId: this.venderId,
            skuIds: [],
            itemList: [],
          },
        ];
        item.sellerSkuList = !isReset&&item.sellerSkuList.length>0 ? item.sellerSkuList : [
          {
            venderId: this.venderId,
            skuIds: [],
            itemList: [],
          },
        ];
        item.multiShopGoods = !isReset&&item.multiShopGoods.length>1 ? item.multiShopGoods : useValidateMultiShopGoods(this, [this.venderId]);
      })
    },
    //点击下单时间显示提示，同时动态设置时分秒选择范围
    orderFocus() {
            
            // 获取当前时间
            const now = new Date();
            
            // 计算当前时间一小时后
            const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000);
            const timeStr = oneHourLater.toTimeString().substring(0, 8);
            console.log(timeStr,'8578787');
            
            // 更新结束时间选择器的时分秒范围
            // 注意：由于Element UI的限制，这个更新可能不会立即生效
            // 需要用户重新打开日期选择器
            this.pickerOptionsValueEnd.selectableRange = `${timeStr} - 23:59:59`;
    },
    checkStepValue(val, index) {
      let newVal = val;
      // 确保输入值不超过最大打卡阶梯次数
      const maxCount = this.prizeSettingListLevel.length;
      if (Number(newVal) > maxCount) {
        newVal = maxCount;
        this.$message.warning(`达标条件不能超过周期次数`);
      }
      if (newVal == 0) {
        newVal = "";
      }

      // 如果不是第一个阶梯，检查是否小于上一个阶梯的达标条件
      if (index > 0 && newVal > 0) {
        const prevItem = this.cumulativeTierList[index - 1];
        const prevValue = Number(prevItem.requiredCheckInCount);
        const currentValue = Number(newVal);

        // 如果当前阶梯的值小于上一个阶梯的值，则调整为上一个阶梯的值
        if (currentValue <= prevValue) {
          newVal = "";
          this.$message.warning(
            `第${index + 1}阶梯的达标条件不能小于第${index}阶梯的达标条件`
          );
        }
      } else if (index == 0 && newVal > 0&&this.cumulativeTierList.length>1) {
        const nextItem = this.cumulativeTierList[index + 1];
        const nextValue = Number(nextItem.requiredCheckInCount);
        const currentValue = Number(newVal);
        if (currentValue >= nextValue && nextValue) {
          newVal = "";
          this.$message.warning(
            `第${index + 1}阶梯的达标条件不能大于第${index + 2}阶梯的达标条件`
          );
        }
      }
      return newVal;
    },
    // 监听报名时间聚焦，设置时分秒限制
    applyFocus() {
      if (this.ruleForm.startTime) {
        this.pickerOptionApply = {
          ...this.pickerOptionApply,
          selectableRange: this.getSelectableRange(),
        };
      }
    },
    // 判断是否为同一天
    isSameDay(date1, date2) {
      return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
      );
    },
    getSelectableRange() {
      // 当applyTimeStart和startTime是同一天时，限制时间选择范围
      if (
        this.isSameDay(
          new Date(this.ruleForm.applyTimeStart),
          new Date(this.ruleForm.startTime)
        )
      ) {
        const start = new Date(this.ruleForm.startTime);
        // 生成限制范围：从startTime的时间开始到23:59:59
        const startTime = `${start
          .getHours()
          .toString()
          .padStart(2, "0")}:${start
          .getMinutes()
          .toString()
          .padStart(2, "0")}:${start.getSeconds().toString().padStart(2, "0")}`;
        return `${startTime} - 23:59:59`;
      }
      return "00:00:00 - 23:59:59";
    },
    // 判断周期时间是否晚于活动结束时间
    checkCycleEndTime() {
      let isAfter = false;
      let endTime =
        this.prizeSettingListLevel[this.prizeSettingListLevel.length - 1]
          .cycleEndTime;
      if (
        this.ruleForm.endTime &&
        endTime &&
        !this.ruleForm.syncLastCycleEndTimeFlag
      ) {
        if (
          new Date(this.ruleForm.endTime).getTime() <=
          new Date(endTime).getTime()
        ) {
          this.$message.error("活动结束时间需晚于周期结束时间");
          isAfter = true;
        }
      }
      return isAfter;
    },
    // 获取最晚周期结束时间
    getLatestCycleEndTime() {
      return this.prizeSettingListLevel.reduce((latest, cycle) => {
        const currentTime = new Date(cycle.cycleEndTime).getTime();
        const latestTime = latest ? new Date(latest).getTime() : 0;
        return currentTime > latestTime ? cycle.cycleEndTime : latest;
      }, null);
    },
    // 判断进行中的活动周期是否结束
    isCycleEnd(item) {
      // 非进行中活动允许编辑
      if (!this.activityData.isStart) return false;

      // 在原始周期数组中查找匹配项
      const originItem = this.originCycleArr.find((c) => c.id === item.id);

      if (originItem) {
        // 当前时间 > 原周期结束时间 → 已结束
        return new Date() > new Date(originItem.cycleEndTime);
      }

      return false;
    },
    // 判断活动周期是否开始
    isCycleStart(item) {
      // 非进行中活动允许编辑
      if (!this.activityData.isStart) return false;

      // 在原始周期数组中查找匹配项
      const originItem = this.originCycleArr.find((c) => c.id === item.id);

      if (originItem) {
        // 当前时间 > 原周期开始时间 → 已开始
        return new Date() > new Date(originItem.cycleStartTime);
      }

      return false; // 新增周期允许编辑
    },
    // 判断该奖品是否包含
    isHavePrize(item, index) {
      const originItem = this.originCycleArr.find((c) => c.id === item.id);
      if (originItem && originItem.settingList.length > 0) {
        if (originItem.settingList[index]) {
          return true;
        }
      }
      return false;
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },

    // 限制进行中的活动报名人数只能增加不能减少
    applyLimitNumChange() {
      let num = this.getLimit(this.ruleForm.applyLimitNum, 0, 100000, 1);
      // 活动进行中报名名额可增加不可减少
      if (
        !this.activityData.isStart &&
        Number(num) < this.originApplyLimitNum
      ) {
        this.ruleForm.applyLimitNum = this.originApplyLimitNum;
        this.$message.warning("活动进行中报名名额可增加不可减少");
        return;
      }
      this.ruleForm.applyLimitNum = num;
    },
    handleChangeCycleTime(item) {
      let endTime = item.cycleEndTime;
      let startTime = item.cycleStartTime;
      if (
        endTime &&
        startTime &&
        new Date(endTime).getTime() <= new Date(startTime).getTime()
      ) {
        this.$message.error("周期开始时间不可晚于结束时间");
        item.cycleEndTime = "";
      }

      // 同步最后一个周期时显示活动持续时间
      let actEndTime =
        this.prizeSettingListLevel[this.prizeSettingListLevel.length - 1]
          .cycleEndTime;
      let actsStartTime = this.ruleForm.startTime;
      if (this.ruleForm.syncLastCycleEndTimeFlag) {
        if (actsStartTime && actEndTime) {
          // 更换组件后需要更换时间计算方法
          this.timeDay = Math.floor(
            Math.abs(new Date(actEndTime) - new Date(actsStartTime)) /
              1000 /
              60 /
              60 /
              24
          );

          //计算小时
          let date3 =
            new Date(actEndTime).getTime() - new Date(actsStartTime).getTime();
          var leave1 = date3 % (24 * 3600 * 1000);
          this.timeOut = Math.floor(leave1 / (3600 * 1000));
        } else {
          this.timeDay = 0;
          this.timeOut = 0;
        }
      }
    },
    applyTimeChange() {
      // 如果报名开始时间选择的日期是活动开始时间当天则赋值活动开始时间
      if (
        this.isSameDay(
          new Date(this.ruleForm.applyTimeStart),
          new Date(this.ruleForm.startTime)
        )
      ) {
        this.ruleForm.applyTimeStart = this.ruleForm.startTime;
      }
      let applyStart = new Date(this.ruleForm.applyTimeStart).valueOf();
      let applyEnd = new Date(this.ruleForm.applyTimeEnd).valueOf();
      if (applyStart > applyEnd) {
        this.$message.error("报名开始时间不可晚于结束时间");
        this.ruleForm.applyTimeEnd = "";
      }
    },
    confirmQuickConfig(cycleArr) {
      this.activeCollapse = [0];
      this.prizeSettingListLevel = cycleArr;
    },

    openQuickConfig() {
      this.isShowQuickConfig = true;
    },

    // 周期-商品选择弹窗控制
    handleOpenCycleOrderWare(item) {
      this.nowSelectCycle = item;
      this.selectGoodsStateCycle = true;
      if (item.orderWareList.length == 0) {
        this.itemListForCycle = [];
        item.orderWareList = [];
      } else {
        this.itemListForCycle = item.orderWareList;
      }
      this.$refs.selectGoCycle.handleRightCurrentChange(1);
    },
    // 周期-商品要求切换
    handleChangeCycleOrder(item) {
      this.nowSelectCycle = item;
      item.orderWareList = [];
      this.itemListForCycle = [];
    },
    // 周期-商品弹窗回调
    handleCycleOrderWareClose(data) {
      if (data) {
        console.log("周期-商品弹窗回调", data);
        this.itemListForCycle = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          fomeVaule.wareId = data[index].wareId;
          this.itemListForCycle.push(fomeVaule);
        });
        this.nowSelectCycle.orderWareList = this.itemListForCycle;
      }
      this.selectGoodsStateCycle = false;
    },
    cycleTimeChange(val) {
      console.log(val, "周期时间");
    },
    // 删除周期
    delCycle(index) {
      this.$confirm(`是否确认删除周期${index + 1}`, "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.prizeSettingListLevel.splice(index, 1);
      });
    },
    delStepList(index) {
      this.$confirm(`是否确认删除阶梯${index + 1}`, "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.cumulativeTierList.splice(index, 1);
        this.cumulativeTierList.forEach((item, index) => {
          item.tierSort = index;
        });
      });
    },
    // 复制周期
    copyCycle(item) {
      if (this.prizeSettingListLevel.length >= 12) {
        this.$message.warning("最多只能添加12个周期");
        return;
      }
      const copiedItem = JSON.parse(JSON.stringify(item));
      let length = this.prizeSettingListLevel.length;
      let beforeTimeEnd = this.prizeSettingListLevel[length - 1].cycleEndTime;

      // 处理时间进位
      if (beforeTimeEnd) {
        const endDate = new Date(beforeTimeEnd);
        // 修复时间计算：使用本地时间而非UTC时间
        endDate.setTime(endDate.getTime() + 1000); // 直接增加1000毫秒（1秒）
        // 生成本地时间字符串（解决时区偏移问题）
        const pad = (n) => n.toString().padStart(2, "0");
        copiedItem.cycleStartTime =
          `${endDate.getFullYear()}-${pad(endDate.getMonth() + 1)}-${pad(
            endDate.getDate()
          )} ` +
          `${pad(endDate.getHours())}:${pad(endDate.getMinutes())}:${pad(
            endDate.getSeconds()
          )}`;
      } else {
        copiedItem.cycleStartTime = "";
      }
      copiedItem.cycleEndTime = ""; // 清空结束时间
      copiedItem.id = ""; // 清空ID
      if(copiedItem.settingList&&copiedItem.settingList.length>0) {
        copiedItem.settingList.forEach((row)=>{
          if(row.id) {
            row.id = "";
            row.cycleInfoId = ""
          }
        })
      }
      this.prizeSettingListLevel.push(copiedItem);
    },
    addCycle() {
      // 最后一个周期如果有时间，则将时间加1秒作为新周期的开始时间
      let length = this.prizeSettingListLevel.length;
      let beforeTimeEnd =
        this.prizeSettingListLevel.length > 0
          ? this.prizeSettingListLevel[length - 1].cycleEndTime
          : [];
      let addTimeStart = "";
      if (beforeTimeEnd) {
        // 将字符串转换为Date对象
        const date = new Date(beforeTimeEnd);
        date.setSeconds(date.getSeconds() + 1);
        // 将Date对象转换回字符串
        const pad = (n) => n.toString().padStart(2, "0");
        addTimeStart =
          `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
            date.getDate()
          )} ` + // 注意这里用 + 连接
          `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
            date.getSeconds()
          )}`;
      }
      this.prizeSettingListLevel.push({
        sortIndex: 0,
        cycleName: "",
        cycleStartTime: addTimeStart,
        cycleEndTime: "",
        orderWareType: 0, // 商品要求类型
        filterSkuType: 0, // 指定商品规则
        orderWareList: [], // 商品要求
        orderPaymentType: 1, //金额统计类型
        checkInConditionType: 0, // 打卡达标条件
        combinationConditionMode: 0, // 组合类型
        orderAmountThreshold: "", // 消费金额
        orderNumThreshold: "", // 消费笔数
        itemNumThreshold: "", // 消费件数
        singleConditionType: 0, // 单一条件
        combinationTypeCheck: [],
        settingList: [
          {
            index: 0,
            prizeType: null,
            price: null,
            logo: null,
            title: "",
            totalAmount: null,
          },
        ],
        venderIds: [],
        sellerSkuList: [],
        multiShopGoods: [],
      });
      this.initData()
    },
    addStepList() {
      this.cumulativeTierList.push({
        tierSort: 0,
        tierName: "",
        requiredCheckInCount: "",
        prizeList: [
          {
            index: 0,
            prizeType: null,
            price: null,
            logo: null,
            title: null,
            totalAmount: null,
          },
        ],
      });
    },
    // 初始化设置周期
    resetCycles() {
      this.$confirm("是否确认重置已设置的周期？重置后不可撤销", "重置周期", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.prizeSettingListLevel = [
          {
            sortIndex: 0,
            cycleName: "",
            cycleStartTime: this.ruleForm.startTime,
            cycleEndTime: "",
            orderWareType: 0, // 商品要求类型
            filterSkuType: 0, // 指定商品规则
            orderWareList: [], // 要求商品
            orderPaymentType: 1, //金额统计类型
            checkInConditionType: 0, // 打卡达标条件
            combinationConditionMode: 0, // 组合类型
            orderAmountThreshold: "", // 消费金额
            orderNumThreshold: "", // 消费笔数
            itemNumThreshold: "", // 消费件数
            singleConditionType: 0, // 单一条件
            combinationTypeCheck: [],

            settingList: [
              {
                index: 0,
                prizeType: null,
                price: null,
                logo: null,
                title: "",
                totalAmount: null,
              },
            ],
            venderIds: [],
            sellerSkuList: [],
            multiShopGoods: [],
          },
          {
            sortIndex: 0,
            cycleName: "",
            cycleStartTime: "",
            cycleEndTime: "",
            orderWareType: 0, // 商品要求类型
            filterSkuType: 0, // 指定商品规则
            orderWareList: [], // 要求商品
            orderPaymentType: 1, //金额统计类型
            checkInConditionType: 0, // 打卡达标条件
            combinationConditionMode: 0, // 组合类型
            orderAmountThreshold: "", // 消费金额
            orderNumThreshold: "", // 消费笔数
            itemNumThreshold: "", // 消费件数
            singleConditionType: 0, // 单一条件
            combinationTypeCheck: [],

            settingList: [
              {
                index: 0,
                prizeType: null,
                price: null,
                logo: null,
                title: "",
                totalAmount: null,
              },
            ],
            venderIds: [],
            sellerSkuList: [],
            multiShopGoods: [],
          },
        ];
        this.initData(true)
      });
    },
    setPrizeList() {
      console.log("初始化周期设置");
      this.prizeSettingListLevel = [
        {
          sortIndex: 0,
          cycleName: "",
          cycleStartTime: this.ruleForm.startTime,
          cycleEndTime: "",
          orderWareType: 0, // 商品要求类型
          filterSkuType: 0, // 指定商品规则
          orderWareList: [], // 要求商品
          orderPaymentType: 1, //金额统计类型
          checkInConditionType: 0, // 打卡达标条件
          combinationConditionMode: 0, // 组合类型
          orderAmountThreshold: "", // 消费金额
          orderNumThreshold: "", // 消费笔数
          itemNumThreshold: "", // 消费件数
          singleConditionType: 0, // 单一条件
          combinationTypeCheck: [],
          mergeOrder: false, // 订单拆单后是否合并

          settingList: [
            {
              index: 0,
              prizeType: null,
              price: null,
              logo: null,
              title: "",
              totalAmount: null,
            },
          ],
          venderIds: [],
          sellerSkuList: [],
          multiShopGoods: [],
        },
        {
          sortIndex: 0,
          cycleName: "",
          cycleStartTime: "",
          cycleEndTime: "",
          orderWareType: 0, // 商品要求类型
          filterSkuType: 0, // 指定商品规则
          orderWareList: [], // 要求商品
          orderPaymentType: 1, //金额统计类型
          checkInConditionType: 0, // 打卡达标条件
          combinationConditionMode: 0, // 组合类型
          orderAmountThreshold: "", // 消费金额
          orderNumThreshold: "", // 消费笔数
          itemNumThreshold: "", // 消费件数
          singleConditionType: 0, // 单一条件
          combinationTypeCheck: [],
          mergeOrder: false, // 订单拆单后是否合并

          settingList: [
            {
              index: 0,
              prizeType: null,
              price: null,
              logo: null,
              title: "",
              totalAmount: null,
            },
          ],
          venderIds: [],
          sellerSkuList: [],
          multiShopGoods: [],
        },
      ];
      this.initData()
      // if (this.valueRow) {
      //   this.getEdit();
      // }
    },
    // 初始化累计打卡阶梯
    initCumulativeTierList() {
      this.cumulativeTierList = [
        {
          tierSort: 0,
          tierName: "",
          requiredCheckInCount: "",
          prizeList: [
            {
              index: 0,
              prizeType: null,
              price: null,
              logo: null,
              title: null,
              totalAmount: null,
            },
          ],
        },
      ];
    },
    // 同步
    synchronizeChange(val) {
      if (val) {
        this.ruleForm.endTime = "";
      }
      this.timeDay = 0;
      this.timeOut = 0;
    },
    changeParticipateType(type) {
      this.isSignLimitTime = false; // 报名限制
      this.isSignLimitNum = false; // 报名限制
      // 免报名活动不支持配置“参与条件”（关注抖音号/授权私信能力）与“会员身份限制
      this.ruleForm.condFollow = false; // 参与条件
      this.ruleForm.applyTimeStart = "";
      this.ruleForm.applyTimeEnd = "";
    },

    //周期奖品-选择
    centerVis2(scope, item) {
      this.nowSelectCycle = item;
      this.tableIndex = scope.$index;
      this.echoDate = scope.row;
      this.showSelectProduct = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },

    //阶梯奖品-选择
    selectStepPrize(scope, item) {
      this.nowSelectStepPrize = item;
      this.tableIndex1 = scope.$index;
      this.echoDate1 = scope.row;
      this.showSelectProduct1 = true;
      this.$nextTick(() => {
        this.$refs.selectProduct1.openDialog();
      });
    },

    // 添加奖项
    addSetting(item) {
      if (this.backgroundOpacity) return;
      if (item.settingList.length >= 10)
        return this.$message.warning("最多只能设置10个奖品");
      item.sortIndex = item.sortIndex + 1;
      item.settingList.push({
        index: 0,
        prizeType: null,
        price: null,
        totalAmount: null,
        title: null,
        remanentAmount: null,
      });
    },
    addStepPrize(item) {
      if (this.backgroundOpacity) return;
      if (item.prizeList.length >= 30)
        return this.$message.warning("最多只能设置30个奖品");
      item.sortIndex = item.sortIndex + 1;
      item.prizeList.push({
        index: item.prizeList.length - 1,
        prizeType: null,
        price: null,
        totalAmount: null,
        title: null,
        remanentAmount: null,
      });
    },
    // 删除
    itemDel(index, item) {
      item.sortIndex -= 1;
      item.settingList.splice(index, 1);
    },
    itemStepPrizeDel(index, item) {
      item.prizeList.splice(index, 1);
    },
    filterTypeChange(val) {
      if (val == 0) {
        this.selectGoodsArr = [];
      } else if (val == 1) {
        this.selectGoodsArr = this.includeArr;
      } else if (val == 2) {
        this.selectGoodsArr = this.excludeArr;
      }
    },
    // 改变数量值
    confirmAdd(num) {
      if (
        this.cumulativeTierIndex !== null &&
        this.cumulativePrizeIndex !== null
      ) {
        this.$set(
          this.cumulativeTierList[this.cumulativeTierIndex].prizeList[
            this.cumulativePrizeIndex
          ],
          "totalAmount",
          Number(num)
        );
      } else {
        this.$set(this.toAddItem, "totalAmount", Number(num));
      }
      this.isShowAddNum = false;
      this.tableKey++;
    },
    // 获取相关数据打开弹窗
    itemAddNum(row, cumulativeTierIndex = null, cumulativePrizeIndex = null) {
      this.cumulativeTierIndex = cumulativeTierIndex;
      this.cumulativePrizeIndex = cumulativePrizeIndex;
      const isCumulativePrize =
        cumulativeTierIndex !== null && cumulativePrizeIndex !== null;
      this.toAddItem = isCumulativePrize
        ? { ...row, num: row.totalAmount || 0 }
        : row;
      if (!isCumulativePrize) {
        this.toAddItem.num = row.totalAmount;
      }
      if (!this.toAddItem.title || this.toAddItem.title == "谢谢参与") {
        this.$message.error("没有奖品不能设置数量！");
        return;
      }
      this.isShowAddNum = true;
    },
    // 1.14迭代
    clearNewTime() {
      this.ruleDto.openCardStartTime = "";
      this.ruleDto.openCardEndTime = "";
    },
    // 打开选择人群
    openCrowd() {
      this.peopleList = this.peopleSelected.map((item) => {
        return { id: item };
      });
      this.selectPeopleShow = true;
      this.actMember = "3";
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
      this.selectPeopleShow = false;
    },
    // 京东计划数量计算
    prizeNum(row) {
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },

    exposureSwitchChange(val) {
      if (!val) {
        this.itemListForFilter = [];
        this.mainImagelist = [];
        this.selectGoodsFilterArr = [];
      }
    },
    selectGoodsCloseFilter(data) {
      if (data) {
        this.itemListForFilter = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListForFilter.push(fomeVaule);
        });
        this.selectGoodsFilterArr = this.itemListForFilter;
        this.mainImagelist = this.itemListForFilter;
      }
      this.selectGoodsStateFilter = false;
    },
    exposureProductsFiter() {
      this.selectGoodsStateFilter = true;
      if (this.itemListForFilter.length == 0) {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
      }
      this.$refs.selectGoFilter.handleRightCurrentChange(1);
    },
    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListForFilter.splice(index, 1);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      const order = this.mainImagelist.map((item) => item.skuId);
      this.itemListForFilter.sort((a, b) => {
        return order.indexOf(a.skuId) - order.indexOf(b.skuId);
      });
      this.selectGoodsFilterArr = this.itemListForFilter;
    },
    // 活动进行中修改奖品数量
    beAdd(row) {
      if (this.activityData.isStart) {
        if (Number(row.totalAmount) < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    // 奖品logo校验
    async beforeUpload(file) {
      const status = await this.imgchecked(file, 202, 202);
      if (!status) {
        return false;
      }
      const isLt3M = file.size < 1024 * 1024;

      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过1MB");
        return false;
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 奖品logo上传成功
    handleUpload(res, row) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        row.logo = res.data;
        this.tableKey++;
      }
    },
    //上传图片前校验   分享设置
    async beforeUpload1(file) {
      const status = await this.imgchecked(file);
      console.log(status);
      if (!status) {
        return false;
      }
      const isLt3M = file.size < 1024 * 1024;

      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];

      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false;
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  分享设置
    handleUpload1(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        this.ruleForm.sharePic = res.data;
      }
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let image = new Image();
        let _URL = window.URL || window.webkitURL;
        image.onload = function () {
          const valid = image.width == width && image.height == height;
          file.isFlag = valid;
          if (valid) {
            resolve(true);
          } else {
            _this.$message.info("图片尺寸不符合要求，请重新上传");
            reject();
          }
        };
        image.src = _URL.createObjectURL(file);
      });
    },
    // 重置背景图  分享设置
    picUrlReset1() {
      this.ruleForm.sharePic = this.sharePic;
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    handleNav(item, index) {
      this.tabActive = index;
      this.navItem = item;
      this.getPolite();
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      const { data } = await hdTaskTemplateGroup({
        hdTaskType: this.activityData.id,
      });
      this.tempSwitchList = [
        {
          id: -1,
          groupName: "全部",
          frontHide: false,
        },
        ...data,
      ];
      this.tempSwitchList.map((item) => {
        item.isVisible = true;
        item.title = item.groupName;
      });
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.navItem.id == -1 ? "" : this.navItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList = data.records.map((item) => {
        return {
          ...item,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        };
      });
      if (!this.valueRow) {
        this.templateId = this.giftList[0].id;
      }
      this.pageData.total = data.total * 1;
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },

    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },

    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      let url = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=";
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: `${url}${this.giftList[index].imageUrl}`,
        });
      }
    },

    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 140, // 设置宽度，单位像素
        height: 140, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        if (
          row.quantityTotal &&
          row.price &&
          row.totalAmount &&
          row.prizeType == 2
        ) {
          let numTotal = this.$jingdouTotal({
            ...row,
            prizeCount: row.totalAmount,
          });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.totalAmount;
        }
      }
    },
    //生成规则
    generateRule() {
      let text1 = "参与方式：",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "",
        text9 = "",
        text10 = "",
        secondText = "\n二、【如何获奖】",
        thirdText = "\n三、【注意事项】";
        const {firstText,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleDto,this.actMember)
      if(this.ruleForm.applyType==0) {
        text1+= "报名时间范围内，进入活动手动报名参与；"
      } else {
        text1+= "有效时间范围内，下单满足条件自动报名参与；"
      }


      // 报名时间
      if (this.ruleForm.applyType == 0) {
        if (this.isSignLimitTime) {
          text6 = `报名时间：${this.ruleForm.applyTimeStart}至${this.ruleForm.applyTimeEnd}`;
        } else {
          text6 = "报名时间：活动期间均可报名参与";
        }
        if (this.isSignLimitNum) {
          text7 = `报名名额：名额有限，先报先得`;
        } else {
          text7 = `报名名额：不限名额`;
        }
      } else {
        text6 = "报名时间：活动期间下单或进入活动后符合条件将自动参与";
        text7 = `报名名额：不限名额`;
      }

      // 活动周期说明
      let textArr = [];
      let cycleArr = this.deepClone(this.prizeSettingListLevel);
      cycleArr.forEach((item, index) => {
        let text =
          `（${index + 1}）${item.cycleName}` +
          "\n" +
          `周期时间：${item.cycleStartTime}-${item.cycleEndTime}；` +
          "\n";

        let buyText = "";
        let numText = "";
        let missionText = "打卡任务：";
        let rewardText = "奖励：";

        if (item.orderWareType == 1) {
          buyText = "购买指定商品";
        } else if (item.orderWareType == 2 || item.orderWareType == 0) {
          buyText = "购买商品";
        }

        if (item.checkInConditionType == 0) {
          // 单一条件
          if (item.singleConditionType == 0) {
            numText = `满${item.orderAmountThreshold}元;`;
          } else if (item.singleConditionType == 1) {
            numText = `满${item.itemNumThreshold}件;`;
          } else if (item.singleConditionType == 2) {
            numText = `满${item.orderNumThreshold}笔;`;
          }
          missionText = missionText + `周期时间内${buyText}${numText}`;
        } else {
          // 组合条件
          missionText =
            missionText +
            (item.combinationConditionMode == 0
              ? "满足所有条件"
              : "满足任一条件即可");

          if (item.combinationTypeCheck.includes(0)) {
            numText = numText + `${buyText}满${item.orderAmountThreshold}元;`;
          }
          if (item.combinationTypeCheck.includes(1)) {
            numText = numText + `${buyText}满${item.itemNumThreshold}件;`;
          }
          if (item.combinationTypeCheck.includes(2)) {
            numText = numText + `${buyText}满${item.orderNumThreshold}笔;`;
          }
          missionText = missionText + `————周期时间内${numText}`;
        }

        // 奖品
        let isHas = item.settingList.some((it) => it.prizeType);
        item.settingList.forEach((it, idx) => {
          rewardText =
            rewardText +
            `${it.title}，数量：${it.totalAmount}${
              it.prizeType != 4 ? `，价值：${it.price}元` : ""
            }${
              idx == item.settingList.length - 1 && cycleArr.length - 1 == index
                ? ""
                : ";\n"
            }`;
        });
        text = text + missionText + "\n" + (isHas ? rewardText : "无奖励" + (cycleArr.length-1!=index ? ";\n" : ""));
        textArr.push(text);
      });
      text8 =
        `活动分为${this.prizeSettingListLevel.length}个周期，消费者需在指定周期时间范围内完成对应消费打卡任务，成功打卡后将获得对应奖励，奖品库存有限，发完即止。` +
        "\n";
      textArr.forEach((item, index) => {
        text8 = text8 + item;
      });
        let Arr1 = [
          firstText,
          [secondText, text1,text6,text7,text8],
          [thirdText, precautions]
        ];
        let newText = "";

        Arr1.forEach((item, index) => {
          let newNum = 0;
          item.forEach((row, it) => {
            if (row.length > 0) {
              if (it != 0) {
                newText = newText + newNum + "." + row + "\n";
              } else {
                newText = newText + row + "\n";
              }
              newNum = newNum + 1;
            }
          });
        });

      this.ruleForm.ruleDescription = newText + text9;
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    // 获取奖品
    getTheData(data, prizeType) {
      let index = this.tableIndex;
      if (prizeType == 1) {
        this.nowSelectCycle.settingList[index].couponType = data.couponType;
      }
      if (data.giftType) {
        this.nowSelectCycle.settingList[index].giftType = Number(data.giftType);
      }
      this.nowSelectCycle.settingList[index].price = Number(data.discount);

      this.nowSelectCycle.settingList[index].assetsId = Number(data.couponId || data.skuId);
      this.nowSelectCycle.settingList[index].logo =
        data.logo || this.defaultLogo;
      this.nowSelectCycle.settingList[index].prizeType = prizeType;
      this.nowSelectCycle.settingList[index].title = data.name;
      if (prizeType == 4) {
        this.nowSelectCycle.settingList[index].title =
          data.discount + "店铺积分";
      } else {
        this.nowSelectCycle.settingList[index].title = data.name;
      }

      if (data.singleAmount) {
        this.nowSelectCycle.settingList[index].singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        this.nowSelectCycle.settingList[index].quantityTotal =
          data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          this.nowSelectCycle.settingList[index].skuId = data.skuId;
          delete this.nowSelectCycle.settingList[index].isGoodManage;
        } else {
          this.nowSelectCycle.settingList[index].isGoodManage =
            data.isGoodManage;
        }
        this.nowSelectCycle.settingList[index].isFollowActivityEndTime =
          data.isFollowActivityEndTime;
        this.nowSelectCycle.settingList[index].addressFillEndTime =
          data.addressFillEndTime;
        this.nowSelectCycle.settingList[index].predictSendTime =
          data.predictSendTime;
        this.nowSelectCycle.settingList[index].shouldCollectExtraData = data.shouldCollectExtraData;
        this.nowSelectCycle.settingList[index].extraQuestion = data.extraQuestion;
        this.nowSelectCycle.settingList[index].addressFillLimit = data.addressFillLimit;
        this.nowSelectCycle.settingList[index].commitAddressLimit = data.commitAddressLimit;
      }
      // 实物随单发
      if(prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(this.nowSelectCycle.settingList[index],prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        this.nowSelectCycle.settingList[index].budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        this.nowSelectCycle.settingList[index].budgetRemain = data.budgetRemain;
      }
      this.showSelectProduct = false;
    },
    // 获取奖品
    getTheData1(data, prizeType) {
      let index = this.tableIndex1;
      if (prizeType == 1) {
        this.nowSelectStepPrize.prizeList[index].couponType = data.couponType;
      }
      if (data.giftType) {
        this.nowSelectStepPrize.prizeList[index].giftType = Number(
          data.giftType
        );
      }
      this.nowSelectStepPrize.prizeList[index].price = Number(data.discount);

      this.nowSelectStepPrize.prizeList[index].assetsId = Number(data.couponId || data.skuId);
      this.nowSelectStepPrize.prizeList[index].logo =
        data.logo || this.defaultLogo;
      this.nowSelectStepPrize.prizeList[index].prizeType = prizeType;
      this.nowSelectStepPrize.prizeList[index].title = data.name;
      if (prizeType == 4) {
        this.nowSelectStepPrize.prizeList[index].title =
          data.discount + "店铺积分";
      } else {
        this.nowSelectStepPrize.prizeList[index].title = data.name;
      }

      if (data.singleAmount) {
        this.nowSelectStepPrize.prizeList[index].singleAmount =
          data.singleAmount;
      }
      if (prizeType == 2) {
        this.nowSelectStepPrize.prizeList[index].quantityTotal =
          data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          this.nowSelectStepPrize.prizeList[index].skuId = data.skuId;
          delete this.nowSelectStepPrize.prizeList[index].isGoodManage;
        } else {
          this.nowSelectStepPrize.prizeList[index].isGoodManage =
            data.isGoodManage;
        }
        this.nowSelectStepPrize.prizeList[index].isFollowActivityEndTime =
          data.isFollowActivityEndTime;
        this.nowSelectStepPrize.prizeList[index].addressFillEndTime =
          data.addressFillEndTime;
        this.nowSelectStepPrize.prizeList[index].predictSendTime =
          data.predictSendTime;
        this.nowSelectStepPrize.prizeList[index].shouldCollectExtraData = data.shouldCollectExtraData;
        this.nowSelectStepPrize.prizeList[index].extraQuestion = data.extraQuestion;
      }
      // 实物随单发
      if(prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(this.nowSelectStepPrize.prizeList[index],prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        this.nowSelectStepPrize.prizeList[index].budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        this.nowSelectStepPrize.prizeList[index].budgetRemain = data.budgetRemain;
      }
      this.showSelectProduct1 = false;
    },
    // 下一步
    resetForm() {
      // 参与方式报名条件
      if (this.ruleForm.applyType == 0) {
        if (
          this.isSignLimitTime &&
          (!this.ruleForm.applyTimeStart || !this.ruleForm.applyTimeEnd)
        ) {
          this.$message.warning("请输入报名时间");
          return;
        }
        if (this.isSignLimitNum && !this.ruleForm.applyLimitNum) {
          this.$message.warning("请输入报名名额");
          return;
        }
      }

      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }

      //活动时间的限制，勾选同步最后一个周期不需要填，接口传参再显示
      if (
        !this.ruleForm.startTime ||
        (!this.ruleForm.endTime && !this.ruleForm.syncLastCycleEndTimeFlag)
      ) {
        this.$message.warning("请输入活动时间");
        return;
      }

      if (this.actMember == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }

      // 1.14迭代 这里判断 指定入会时间
      // if (this.actMember == "2") {
      //   if (
      //     this.ruleDto.isCheckOpenCardTime &&
      //     (!this.ruleDto.openCardStartTime || !this.ruleDto.openCardEndTime)
      //   ) {
      //     this.$message.warning("请选择入会时间");
      //     return;
      //   }
      // }
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType == 1 &&
          !this.ruleForm.openCardBeforeDay
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        if (
          this.ruleForm.firstOpenCardTimeType == 2 &&
          (!this.ruleDto.openCardStartTime || !this.ruleDto.openCardEndTime)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
      }
      // 若同步最后一个周期结束时间
      if (this.ruleForm.syncLastCycleEndTimeFlag) {
        let endTime = this.getLatestCycleEndTime();
        if (
          new Date(this.ruleForm.applyTimeStart).getTime() <
            new Date(this.ruleForm.startTime).getTime() ||
          new Date(this.ruleForm.applyTimeEnd).getTime() >
            new Date(endTime).getTime()
        ) {
          this.$message.warning("报名时间需在活动时间范围内");
          return;
        }
      } else {
        if (
          new Date(this.ruleForm.applyTimeStart).getTime() <
            new Date(this.ruleForm.startTime).getTime() ||
          new Date(this.ruleForm.applyTimeEnd).getTime() >
            new Date(this.ruleForm.endTime).getTime()
        ) {
          this.$message.warning("报名时间需在活动时间范围内");
          return;
        }
      }

      if (this.prizeSettingListLevel.length < 2) {
        this.$message.warning("至少设置2个周期");
        return;
      }

      // 整个周期跨度最多1年
      let startTime = this.prizeSettingListLevel[0].cycleStartTime;
      let endTime =
        this.prizeSettingListLevel[this.prizeSettingListLevel.length - 1]
          .cycleEndTime;
      let oneYear = 1000 * 60 * 60 * 24 * 365;
      if (
        new Date(endTime).getTime() - new Date(startTime).getTime() >
        oneYear
      ) {
        this.$message.warning("周期跨度不能超过1年");
        return;
      }

      // 打卡模式为按购物时间区分则校验周期时间不可重叠
      if (this.ruleForm.checkInMode == 0) {
        const sortedCycles = [...this.prizeSettingListLevel]
          .filter((c) => c.cycleStartTime && c.cycleEndTime)
          .sort(
            (a, b) => new Date(a.cycleStartTime) - new Date(b.cycleStartTime)
          );

        for (let i = 1; i < sortedCycles.length; i++) {
          const prevEnd = new Date(sortedCycles[i - 1].cycleEndTime);
          const currStart = new Date(sortedCycles[i].cycleStartTime);

          if (currStart < prevEnd) {
            this.$message.warning("周期时间存在重叠");
            return;
          }
        }
      }

      // 周期名称不可重复
      let nameArr = [];
      let isNullCycleTime = false;
      let isNullCycleName = false;
      this.prizeSettingListLevel.forEach((item) => {
        if (!item.cycleStartTime || !item.cycleEndTime) {
          isNullCycleTime = true;
        }
        if (!item.cycleName) {
          isNullCycleName = true;
        }
        nameArr.push(item.cycleName);
      });
      if (isNullCycleName) {
        this.$message.warning("请完善周期名称");
        return;
      }
      if (isNullCycleTime) {
        this.$message.warning("请完善周期时间");
        return;
      }
      if (Array.from(new Set(nameArr)).length < nameArr.length) {
        this.$message.warning("周期名称重复，请重新设置");
        return;
      }

      // 累计打卡阶梯校验
      const setpNames = [];
      let isHasTierName = false;
      let isTrue = false;
      let stepIndex = 0;
      let prizeIndex = 0;
      let isHasRequiredCheckInCount = false;
      let isHasPrize = false;
      if (this.ruleForm.cumulativeCheckInRewardEnabled == 1) {
        this.cumulativeTierList.some((item, index) => {
          if (!item.tierName) {
            isHasTierName = true;
            stepIndex = index + 1;
            return true;
          }
          if (!item.requiredCheckInCount) {
            isHasRequiredCheckInCount = true;
            stepIndex = index + 1;
            return true;
          }
          isTrue = item.prizeList.some((row) => {
            if (!row.title && !row.logo && !row.totalAmount) {
              isHasPrize = true;
              return true;
            }
          });
          if (isTrue) {
            prizeIndex = index + 1;
          }
        });
        this.cumulativeTierList.forEach((item) => {
          setpNames.push(item.tierName);
        });
        if (isHasTierName) {
          this.$message.warning(`请完善阶梯${stepIndex}的名称`);
          return;
        }
        if (isHasRequiredCheckInCount) {
          this.$message.warning(`请完善阶梯${stepIndex}的达标条件`);
          return;
        }
        if (isHasPrize) {
          this.$message.warning(`请完善阶梯${prizeIndex}的奖品信息`);
          return;
        }
        if (Array.from(new Set(setpNames)).length < setpNames.length) {
          this.$message.warning("阶梯名称重复，请重新设置");
          return;
        }
      }

      // 同步最后一个周期时间时判断是否超出有效期
      if (this.ruleForm.syncLastCycleEndTimeFlag) {
        let end = new Date(
          this.prizeSettingListLevel[
            this.prizeSettingListLevel.length - 1
          ].cycleEndTime
        ).valueOf();
        let CRMtime = new Date(this.jdCrm.endTime).valueOf();
        // 店铺接入有效期
        let platformInvalidateDate =
          this.$store.getters.loginUserInfo.platformInvalidateDate;
        // 店铺接入有效期
        if (this.softType == 1) {
          // 京获客旗舰版
          platformInvalidateDate =
            this.$store.getters.loginUserInfo.invalidateDate;
        }
        const hdInvalidateDate =
          this.$store.getters.loginUserInfo.hdInvalidateDate;
        let platformInvalidateDateValue = new Date(
          platformInvalidateDate
        ).valueOf();
        // 互动数据授权
        let hdInvalidateDateValue = new Date(hdInvalidateDate).valueOf();
        const platformInvalidateDateStr = platformInvalidateDate
          ? platformInvalidateDate.split(" ")[0]
          : "";
        const hdInvalidateDateStr = hdInvalidateDate
          ? hdInvalidateDate.split(" ")[0]
          : "";
        if (end > CRMtime && this.venderType && CRMtime && end) {
          this.$message.warning("活动有效期不可超过【云短信CRM】订购有效期。");
          return;
        }
        if (end > platformInvalidateDateValue) {
          this.$message.warning(
            `活动时间不可超过店铺接入有效期${platformInvalidateDateStr}，请重新设置！`
          );
          return;
        }
        if (end > hdInvalidateDateValue) {
          this.$message.warning(
            `活动时间不可超过互动数据授权有效期${hdInvalidateDateStr}，请重新设置！`
          );
          return;
        }
      }

      // 指定商品规则勾选
      for (let i = 0; i < this.prizeSettingListLevel.length; i++) {
        let item = this.prizeSettingListLevel[i];
        // if (item.orderWareType >= 1 && item.orderWareList.length == 0) {
        //   return this.$message.warning(
        //     `请勾选${item.orderWareType == 1 ? "指定" : "排除"}商品~`
        //   );
        // }
        const obj = item.sellerSkuList.find((row) => {
          return row.skuIds&&row.skuIds.length == 0;
        })
        if (item.orderWareType >=1&&obj) {
          const shop = item.multiShopGoods.find((item) => {
            return item.venderId == obj.venderId;
          });
          return this.$message.warning(`请选择${shop.shopTitle}的${item.orderWareType == 1 ? "指定" : "排除"}商品`);
        }

        // 打卡达标条件
        if (item.checkInConditionType == 0) {
          if (
            (item.singleConditionType == 0 && !item.orderAmountThreshold) ||
            (item.singleConditionType == 1 && !item.itemNumThreshold) ||
            (item.singleConditionType == 2 && !item.orderNumThreshold)
          ) {
            return this.$message.warning("请完善打卡达标条件");
          }
        } else if (item.checkInConditionType == 1) {
          if (
            item.combinationTypeCheck.length == 0 ||
            (item.combinationTypeCheck.includes(0) &&
              !item.orderAmountThreshold) ||
            (item.combinationTypeCheck.includes(1) && !item.itemNumThreshold) ||
            (item.combinationTypeCheck.includes(2) && !item.orderNumThreshold)
          ) {
            return this.$message.warning("请完善打卡达标条件");
          }
        }
      }

      // 请将奖品填写完整！
      let isFlay = false;
      let isSelectPrize = false;
      let isSameIdPoint = false;
      // 按周期
      this.prizeSettingListLevel.forEach((item) => {
        if (item.settingList.length == 0) {
          isFlay = true;
        }
        item.settingList.some((list) => {
          if (!list.totalAmount || !list.title) {
            isFlay = true;
          }
          if (list.prizeType) {
            isSelectPrize = true;
          }
          // 新增奖品类型为1时的assetsId重复校验
          if (list.prizeType === 1) {
            const sameAssets = item.settingList.filter(
              (l) => l.prizeType === 1 && l.assetsId === list.assetsId
            );
            if (sameAssets.length > 1) {
              isSameIdPoint = true;
            }
          }
        });
        // 一个周期只能设置一个积分奖品
        const samePointAssets = item.settingList.filter(
          (l) => l.prizeType == 4
        );
        if (samePointAssets.length > 1) {
          isSameIdPoint = true;
        }
      });
      if (
        (this.ruleForm.cumulativeCheckInRewardEnabled == 0 && isFlay) ||
        (isSelectPrize && isFlay)
      ) {
        return this.$message.warning("请完善奖品设置填写！");
      }
      if (isSameIdPoint) {
        return this.$message.warning(
          "同一周期奖励(积分/券)不可重复，请重新设置!"
        );
      }

      // 公活动配置校验
      if (!useValidateMoreActSet(this)) {
        return;
      }

      //请添加曝光商品！
      if (this.ruleForm.exposureSwitch) {
        if (this.itemListForFilter.length === 0) {
          this.$message.warning("请添加曝光商品！");
          return;
        }
      }

      // 小程序分享标题
      if (!this.ruleForm.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleForm.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      if(this.placementPosition.length==0) {
        this.$message.warning("请选择活动投放位置！");
        return
      }

      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    handleDialogCloseAnoth() {
      const {
        activityName,
        startTime,
        endTime,
        condFollow,
        radio,
        partner,
        ruleDescription,
        activityTheme,
        activityRemark,
        checkInTitle,
        textColor,
        shareTitle,
        shareIntroduce,
        sharePic,
        cumulativeCheckInRewardEnabled,
        cumulativeRewardClaimType,
        isValidBlackList,
        studentSatus,
      } = this.ruleForm;

      const obj = {
        activityName,
        startTime,
        endTime,
        condFollow: Number(condFollow),
        ruleDTO: {},
        priceType: radio, //  0：显示京东价 1：显示促销
        ruleDescription,
        templateId: this.templateId,
        subType: 53,
        isValidBlackList,
        studentSatus,
      };
      // 活动对象
      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel = partner.join(",");
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
        // 入会时间
        obj.ruleDTO.isCheckOpenCardTime = this.ruleDto.isCheckOpenCardTime;
        obj.ruleDTO.openCardStartTime = this.ruleDto.openCardStartTime;
        obj.ruleDTO.openCardEndTime = this.ruleDto.openCardEndTime;
        obj.ruleDTO.firstOpenCardTimeType = this.ruleForm.firstOpenCardTimeType;
        obj.ruleDTO.openCardBeforeDay = this.ruleForm.openCardBeforeDay;
      }
      obj.ruleDTO.openCardFollow = this.ruleForm.openCardFollow;
      // plus会员
      obj.ruleDTO.plusObject = this.ruleDto.plusObject;
      // 自定义模板
      obj.ruleDTO.cusTemplateJSON = this.ruleDto.cusTemplateJSON;
      // 强制提醒
      obj.ruleDTO.isForceRemind = this.ruleDto.isForceRemind;
      // 是否重点活动
      obj.isKeyActivity = this.isKeyActivity;
      // 活动投放位置
      obj.placementPosition = this.placementPosition.join(",");

      // 奖品设置

      // 周期设置
      let cycleArr = this.prizeSettingListLevel.map((item, index) => {
        let orderAmountThreshold = "";
        let itemNumThreshold = "";
        let orderNumThreshold = "";
        if (item.checkInConditionType == 0) {
          if (item.singleConditionType == 0) {
            orderAmountThreshold = item.orderAmountThreshold; // 消费金额
          }
          if (item.singleConditionType == 1) {
            itemNumThreshold = item.itemNumThreshold; // 消费件数
          }
          if (item.singleConditionType == 2) {
            orderNumThreshold = item.orderNumThreshold; // 消费笔数
          }
        }
        if (item.checkInConditionType == 1) {
          if (item.combinationTypeCheck.includes(0)) {
            orderAmountThreshold = item.orderAmountThreshold; // 消费金额
          }
          if (item.combinationTypeCheck.includes(1)) {
            itemNumThreshold = item.itemNumThreshold; // 消费件数
          }
          if (item.combinationTypeCheck.includes(2)) {
            orderNumThreshold = item.orderNumThreshold; // 消费笔数
          }
        }
        return {
          id: item.id || "",
          sort: index + 1,
          cycleName: item.cycleName, // 周期名称
          cycleStartTime: item.cycleStartTime, // 周期开始时间
          cycleEndTime: item.cycleEndTime, // 周期结束时间
          orderWareType: item.orderWareType, // 商品要求
          filterSkuType: item.filterSkuType||0, // 指定商品规则
          orderWareList: [], // 要求商品
          orderPaymentType: item.orderPaymentType, //金额统计类型
          mergeOrder: item.mergeOrder, // 合并订单
          checkInConditionType: item.checkInConditionType, // 打卡达标条件
          combinationConditionMode: item.combinationConditionMode, // 组合条件
          orderAmountThreshold: orderAmountThreshold, // 消费金额
          orderNumThreshold: orderNumThreshold, // 消费笔数
          itemNumThreshold: itemNumThreshold, // 消费件数
          pointActivityPrizeDTOList: item.settingList.filter(
            (item) => item.prizeType > 0
          ).map((prizeItem) => {
            // 提交地址限制：数组转逗号分隔字符串
            if (prizeItem.prizeType == 3 && Array.isArray(prizeItem.commitAddressLimit)) {
              prizeItem.commitAddressLimit = prizeItem.commitAddressLimit.join(',');
            }
            return prizeItem;
          }), // 周期奖励奖品,草稿过滤掉空奖品
          venderIds: item.venderIds.length > 0 ? item.venderIds : [this.venderId], // 店铺ID
          sellerSkuList: item.sellerSkuList.map(item=>{
            return {
              venderId: item.venderId, // 店铺ID
              skuIds: item.skuIds || [], // 商品ID列表
            }
          })
        };
      });
      // 新增
      obj.ruleDTO.syncLastCycleEndTimeFlag =
        this.ruleForm.syncLastCycleEndTimeFlag;
      obj.ruleDTO.applyType = this.ruleForm.applyType;
      obj.ruleDTO.applyTimeStart = this.ruleForm.applyTimeStart;
      obj.ruleDTO.applyTimeEnd = this.ruleForm.applyTimeEnd;
      obj.ruleDTO.applyLimitNum = this.ruleForm.applyLimitNum;
      obj.ruleDTO.checkInMode = this.ruleForm.checkInMode;
      obj.ruleDTO.orderStatus = this.ruleForm.orderStatus;
      obj.ruleDTO.hideUnStartedCycleDetailsFlag =
        this.ruleForm.hideUnStartedCycleDetailsFlag; // 是否未开始的周期隐藏奖品和打卡达标条件
      obj.ruleDTO.hidePrizeStockInCFlag = this.ruleForm.hidePrizeStockInCFlag; // 不在C端展示奖品库存
      obj.ruleDTO.cycleSettlementMode = this.ruleForm.cycleSettlementMode; // 周期结算规则
      obj.ruleDTO.calendarRemindFlag = this.ruleForm.calendarRemindFlag; // 日历提醒
      obj.ruleDTO.cycleInfoList = cycleArr;
      obj.ruleDTO.cumulativeTierList =
        cumulativeCheckInRewardEnabled == 1 ? this.cumulativeTierList.map((tierItem) => {
          return {
            ...tierItem,
            prizeList: tierItem.prizeList.map((prizeItem) => {
              // 提交地址限制：数组转逗号分隔字符串
              if (prizeItem.prizeType == 3 && Array.isArray(prizeItem.commitAddressLimit)) {
                prizeItem.commitAddressLimit = prizeItem.commitAddressLimit.join(',');
              }
              return prizeItem;
            })
          };
        }) : [];
      // 累计打卡奖励
      obj.ruleDTO.cumulativeCheckInRewardEnabled =
        cumulativeCheckInRewardEnabled;
      // 奖励领取次数
      obj.ruleDTO.cumulativeRewardClaimType = cumulativeRewardClaimType;

      // 勾选同步最后一个周期的结束时间则
      if (this.ruleForm.syncLastCycleEndTimeFlag) {
        obj.endTime = this.getLatestCycleEndTime();
      }
      obj.pointActivityPrizeDTOList = []; // 活动奖项集合

      // 活动页设置
      const activitySetting = {
        activityTheme,
        activityRemark,
        checkInTitle,
        textColor,
      };
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);

      // 曝光商品
      obj.isExposureItem = this.ruleForm.exposureSwitch ? 1 : 0; //是否添加曝光商品 0 否 1 是
      if (obj.isExposureItem) {
        obj.itemList = this.itemListForFilter;
      }
      obj.ruleDTO.multiShopSkuType = this.multiShopSkuType;
      obj.ruleDTO.skuBelongVenderId = this.multiShopSkuType==0 && this.itemListForFilter.length>0 ? this.itemListForFilter[0].belongVenderId : "",

      // 分享设置
      obj.ruleDTO.shareTitle = shareTitle;
      obj.ruleDTO.shareIntroduce = shareIntroduce;
      obj.ruleDTO.sharePic = sharePic;

      if (this.checked == true || this.isDraft) {
        if (this.activityData.isStart) {
          const prizes = [];
          cycleArr.forEach((cycle) => {
            cycle.pointActivityPrizeDTOList.forEach((prize) => {
              prizes.push({
                ...prize,
                prizeId: prize.id,
              });
            });
          });
          obj.ruleDTO.cumulativeTierList.forEach((tier) => {
            tier.prizeList.forEach((prize) => {
              prizes.push({
                ...prize,
                prizeId: prize.id,
              });
            });
          });
          const params = {
            activityId: this.valueRow.id,
            ruleDescription: obj.ruleDescription,
            prizes: prizes.filter((item) => item.id),
            isExposureItem: obj.isExposureItem,
            itemList: obj.isExposureItem ? this.itemListForFilter : [],
            activityName: obj.activityName,
            condFollow: obj.condFollow,
            ruleDto: obj.ruleDTO,
            templateId: this.templateId,
            endTime: obj.endTime,
            isValidBlackList: this.ruleForm.isValidBlackList,
          };
          updateCommon(params)
            .then((res) => {
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(() => {});
        } else {
          if (this.isDraft) {
            obj.status = 5;
          } else {
            // 保存正式活动不需要status
            if (obj.status) delete obj.status;
            if (!this.activityData.isCopy) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
                obj.id = this.valueRow.id;
              }
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
          }
          saveActivityCommon(obj)
            .then((res) => {
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        }
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        getActivityDetailCommon(this.valueRow.id)
          .then((res) => {
            try {
              this.isCreated = true
              const {
                activityName,
                startTime,
                endTime,
                allowLevel,
                condFollow,
                ruleDescription,
                ruleDto,
                pointActivityPrizeDTOList,
                isExposureItem,
                isKeyActivity,
                placementPosition,
                studentSatus,
              } = res.data;
              const {
                customerPaperwork,
                isCheckOpenCardTime,
                openCardStartTime,
                openCardEndTime,
                plusObject,
                cusTemplateJSON,
                isForceRemind,
                shareTitle,
                shareIntroduce,
                sharePic,

                syncLastCycleEndTimeFlag,
                applyTimeStart,
                applyTimeEnd,
                applyLimitNum,
                checkInMode,
                orderStatus,
                hideUnStartedCycleDetailsFlag,
                hidePrizeStockInCFlag, // 不在C端展示奖品库存
                cycleSettlementMode,
                calendarRemindFlag,
                cycleInfoList,
                applyType,
                firstOpenCardTimeType,
                openCardBeforeDay,
                openCardFollow,
                cumulativeCheckInRewardEnabled,
                cumulativeRewardClaimType,
                cumulativeTierList,
                multiShopSkuType,
                skuBelongVenderId,
              } = ruleDto;
              // 活动名称
              let length = (activityName + "复制").length;
              this.ruleForm.activityName =
                activityName +
                (this.activityData.isCopy && length <= 15 ? "复制" : "");
              // 记录活动结束时间
              this.actEndTime = endTime;
              // 活动对象
              if (allowLevel == "99") {
                this.peopleSelected = res.data.crowdIds.split(",");
                this.actMember = "3";
              } else if (allowLevel == "-1") {
                this.actMember = "1";
              } else {
                this.actMember = "2";
                if (allowLevel.indexOf("-1") != -1) {
                  this.ruleForm.partner = ["-1"];
                } else {
                  this.ruleForm.partner = allowLevel.split(",");
                }
              }
              // 模板
              this.templateId = res.data.templateId;
              // 关注
              this.ruleForm.condFollow = Boolean(condFollow);
              // 黑名单
              this.ruleForm.isValidBlackList = res.data.isValidBlackList;
              // 入会时间
              this.ruleDto.isCheckOpenCardTime = isCheckOpenCardTime;
              this.ruleDto.openCardStartTime = openCardStartTime;
              this.ruleDto.openCardEndTime = openCardEndTime;
              // 首次入会时间类型
              this.ruleForm.firstOpenCardTimeType = firstOpenCardTimeType;
              // 参与活动前N天
              this.ruleForm.openCardBeforeDay = openCardBeforeDay;
              // 开卡入会后方可参与活动
              this.ruleForm.openCardFollow = openCardFollow || 1;
              // plus会员
              this.ruleDto.plusObject = plusObject;
              // 自定义模板
              this.ruleDto.cusTemplateJSON = cusTemplateJSON;
              // 强制提醒
              this.ruleDto.isForceRemind = isForceRemind;
              // 是否重点活动
              this.isKeyActivity = isKeyActivity;
              // 活动投放位置
              this.placementPosition = placementPosition ? placementPosition.split(",") : ["SHOP"];
              this.ruleForm.studentSatus = studentSatus || "";
              // 周期
              this.ruleForm.syncLastCycleEndTimeFlag = syncLastCycleEndTimeFlag; // 同步上周期结算时间
              this.ruleForm.applyType = applyType; // 打卡类型
              if (applyTimeStart && applyTimeEnd) {
                this.isSignLimitTime = true;
              }
              if (applyLimitNum) {
                this.isSignLimitNum = true;
              }

              this.ruleForm.applyTimeStart = applyTimeStart;
              this.ruleForm.applyTimeEnd = applyTimeEnd;
              this.ruleForm.applyLimitNum = Number(applyLimitNum); // 打卡次数
              this.originApplyLimitNum = Number(applyLimitNum);

              this.ruleForm.checkInMode = Number(checkInMode); // 打卡模式
              this.ruleForm.orderStatus = Number(orderStatus); // 订单状态
              this.ruleForm.hideUnStartedCycleDetailsFlag =
                hideUnStartedCycleDetailsFlag; // 是否未开始的周期隐藏奖品和打卡达标条件
              this.ruleForm.hidePrizeStockInCFlag = hidePrizeStockInCFlag; // 不在C端展示奖品库存
              this.ruleForm.cycleSettlementMode = Number(cycleSettlementMode); // 周期结算模式
              this.ruleForm.calendarRemindFlag = calendarRemindFlag; // 日历提醒
              // 累计打卡奖励
              this.ruleForm.cumulativeCheckInRewardEnabled =
                cumulativeCheckInRewardEnabled || 0;
              this.ruleForm.cumulativeRewardClaimType =
                cumulativeRewardClaimType || 0;
                if(this.activityData.isCopy) {
                  this.cumulativeTierList = cumulativeTierList&&cumulativeTierList.length> 0 ? cumulativeTierList.map((item) => {
                    return {
                      ...item,
                      prizeList: [
                        {
                          index: 0,
                          prizeType: null,
                          price: null,
                          logo: null,
                          title: null,
                          totalAmount: null,
                        },
                      ],
                    };
                  }) : [
                    {
                      tierSort: 0,
                      tierName: "",
                      requiredCheckInCount: "",
                      prizeList: [
                        {
                          index: 0,
                          prizeType: null,
                          price: null,
                          logo: null,
                          title: null,
                          totalAmount: null,
                        },
                      ],
                    }
                  ]
                } else if(res.data.ruleDto.cumulativeTierList && res.data.ruleDto.cumulativeTierList.length > 0) {
                  this.cumulativeTierList  = cumulativeTierList.map((tierItem) => {
                    return {
                      ...tierItem,
                      prizeList: tierItem.prizeList.map((prizeItem) => {
                        // 提交地址限制回显：逗号分隔字符串转数字数组
                        if (prizeItem.prizeType == 3) {
                          if (prizeItem.commitAddressLimit) {
                            prizeItem.commitAddressLimit = typeof prizeItem.commitAddressLimit === 'string'
                              ? prizeItem.commitAddressLimit.split(',').map(Number)
                              : prizeItem.commitAddressLimit;
                          } else {
                            prizeItem.commitAddressLimit = [0];
                          }
                        }
                        return prizeItem;
                      })
                    };
                  })
                } else {
                  this.cumulativeTierList = [
                    {
                      tierSort: 0,
                      tierName: "",
                      requiredCheckInCount: "",
                      prizeList: [
                        {
                          index: 0,
                          prizeType: null,
                          price: null,
                          logo: null,
                          title: null,
                          totalAmount: null,
                        },
                      ],
                    }
                  ];
                }
              this.prizeSettingListLevel = cycleInfoList.map((item) => {
                let singleConditionType = 0;
                if (
                  item.checkInConditionType == 0 &&
                  item.orderAmountThreshold
                ) {
                  singleConditionType = 0;
                  item.itemNumThreshold = "";
                  item.orderNumThreshold = "";
                } else if (
                  item.checkInConditionType == 0 &&
                  item.itemNumThreshold
                ) {
                  singleConditionType = 1;
                  item.orderAmountThreshold = "";
                  item.orderNumThreshold = "";
                } else if (
                  item.checkInConditionType == 0 &&
                  item.orderNumThreshold
                ) {
                  singleConditionType = 2;
                  item.orderAmountThreshold = "";
                  item.itemNumThreshold = "";
                }
                let combinationTypeCheck = [];
                if (
                  item.checkInConditionType == 1 &&
                  item.orderAmountThreshold
                ) {
                  combinationTypeCheck.push(0);
                }
                if (item.checkInConditionType == 1 && item.itemNumThreshold) {
                  combinationTypeCheck.push(1);
                }
                if (item.checkInConditionType == 1 && item.orderNumThreshold) {
                  combinationTypeCheck.push(2);
                }
                item.venderIds = item.venderIds || [this.venderId]
                item.sellerSkuList = item.sellerSkuList || [{
                    venderId: this.venderId, // 店铺ID
                    skuIds: item.orderWareList&&item.orderWareList.length>0? item.orderWareList.map(row=>row.skuId):[], // 商品ID列表
                    itemList: item.orderWareList,
                  }]
                if (this.activityData.isCopy||this.isDraftEdit) {
                  // 跨店复制
                  if(item.venderIds.length>0) {
                    let index = item.venderIds.findIndex((item)=>{
                      return item == this.venderId
                    })
                    if(index==-1) {
                      item.venderIds.unshift(Number(this.venderId))
                      item.sellerSkuList.unshift({
                        venderId: Number(this.venderId),
                        skuIds: [],
                        itemList: [],
                      })
                    }
                  }
                }
                if(this.isGray) {
                  item.venderIds = [this.venderId]
                  item.sellerSkuList = item.sellerSkuList.filter(row=>row.venderId==this.venderId)
                }
                return {
                  id: this.activityData.isCopy ? "" : item.id || "",
                  sort: item.sort,
                  cycleName: item.cycleName, // 周期名称
                  cycleStartTime: item.cycleStartTime, // 周期开始时间
                  cycleEndTime: item.cycleEndTime, // 周期结束时间
                  orderWareType: item.orderWareType, // 商品要求
                  filterSkuType: item.filterSkuType||0, // 指定商品规则
                  orderWareList: item.orderWareList || [], // 要求商品
                  orderPaymentType:
                    item.orderPaymentType,
                    // || this.venderType ? 1 : 0, //金额统计类型
                  checkInConditionType: item.checkInConditionType, // 打卡达标条件
                  combinationConditionMode: item.combinationConditionMode, // 组合条件
                  orderAmountThreshold: item.orderAmountThreshold, // 消费金额
                  orderNumThreshold: item.orderNumThreshold, // 消费笔数
                  itemNumThreshold: item.itemNumThreshold, // 消费件数
                  singleConditionType: singleConditionType || 0,
                  combinationTypeCheck: combinationTypeCheck || [],
                  settingList:
                    this.activityData.isCopy || !item.pointActivityPrizeDTOList
                      ? [
                          {
                            index: 0,
                            prizeType: null,
                            price: null,
                            totalAmount: null,
                            title: null,
                            remanentAmount: null,
                          },
                        ]
                      : item.pointActivityPrizeDTOList.map((it) => {
                          let goodsObj = it;
                          // 复制清除id
                          if (this.activityData.isCopy) {
                            goodsObj.id = "";
                          }
                          // 提交地址限制回显：逗号分隔字符串转数字数组
                          if (it.prizeType == 3) {
                            if (it.commitAddressLimit) {
                              goodsObj.commitAddressLimit = typeof it.commitAddressLimit === 'string'
                                ? it.commitAddressLimit.split(',').map(Number)
                                : it.commitAddressLimit;
                            } else {
                              goodsObj.commitAddressLimit = [0];
                            }
                          }
                          return goodsObj;
                        }),
                    venderIds:item.venderIds,
                    sellerSkuList:item.sellerSkuList,
                    multiShopGoods: item.venderIds && item.venderIds.length > 0 ? useValidateMultiShopGoods(this, item.venderIds) : [this.venderId],
                    mergeOrder: item.mergeOrder || false,
                };
              });
              this.originCycleArr = this.deepClone(this.prizeSettingListLevel);
              // 曝光商品
              this.ruleForm.exposureSwitch = isExposureItem ? true : false;
              if (this.ruleForm.exposureSwitch) {
                this.itemListForFilter = res.data.itemList;
                this.mainImagelist = res.data.itemList;
                this.selectGoodsFilterArr = res.data.itemList;
              }
              this.multiShopSkuType = multiShopSkuType || 0;
              this.skuBelongVenderId = skuBelongVenderId || "";
              // 活动页设置
              const activitySetting = JSON.parse(customerPaperwork);
              this.ruleForm.activityTheme = activitySetting.activityTheme;
              this.ruleForm.activityRemark = activitySetting.activityRemark;
              this.ruleForm.checkInTitle = activitySetting.checkInTitle;
              this.ruleForm.textColor = activitySetting.textColor;
              this.customerPaperwork = activitySetting;

              // 分享设置回显
              this.ruleForm.shareTitle = shareTitle;
              this.ruleForm.shareIntroduce = shareIntroduce;
              this.ruleForm.sharePic = sharePic;

              if (!this.activityData.isCopy) {
                // 活动时间
                this.ruleForm.startTime = startTime;
                this.ruleForm.endTime =
                  this.isDraftEdit && syncLastCycleEndTimeFlag ? "" : endTime;

                this.ruleForm.ruleDescription = ruleDescription;
              }
              this.activityTimeChange();
            } catch (e) {
              console.log(e);
            }
          })
          .catch((res) => {});
      }
    },
    // 初始化时间
    setTime() {
      this.ruleForm.startTime = this.$getDate(30)[0];
      // 判断当前时间是否大于软件有效期
      const endTime = this.$getDate(30)[1];
      const endTimeValue = new Date(endTime).valueOf();
      const expiresIn = this.$store.getters.loginUserInfo.expiresIn;
      let expiresInValue = new Date(expiresIn).valueOf();
      if (endTimeValue > expiresInValue) {
        this.ruleForm.endTime = expiresIn;
      } else {
        this.ruleForm.endTime = endTime;
      }
      //初始化周期列表
      this.setPrizeList();
      this.initCumulativeTierList();
    },
    //清空时间
    clearTime() {
      this.ruleForm.startTime = "";
      this.ruleForm.endTime = "";
    },
    // 活动时间改变
    activityTimeChange() {
      // 创建活动时置空活动结束时间
      if (!this.valueRow && this.ruleForm.syncLastCycleEndTimeFlag) {
        this.ruleForm.endTime = "";
      }

      let checkCycleAndActTime = this.checkCycleEndTime();
      if (checkCycleAndActTime) {
        this.ruleForm.endTime = "";
        return;
      }

      // 校验有无时间
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) return;
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.startTime).valueOf();
      let end = new Date(this.ruleForm.endTime).valueOf();
      let CRMtime = new Date(this.jdCrm.endTime).valueOf();
      // 店铺接入有效期
      let platformInvalidateDate =
        this.$store.getters.loginUserInfo.platformInvalidateDate;
      // 店铺接入有效期
      if (this.softType == 1) {
        // 京获客旗舰版
        platformInvalidateDate =
          this.$store.getters.loginUserInfo.invalidateDate;
      }
      const hdInvalidateDate =
        this.$store.getters.loginUserInfo.hdInvalidateDate;
      let platformInvalidateDateValue = new Date(
        platformInvalidateDate
      ).valueOf();
      // 互动数据授权
      let hdInvalidateDateValue = new Date(hdInvalidateDate).valueOf();
      var date3;
      const platformInvalidateDateStr = platformInvalidateDate
        ? platformInvalidateDate.split(" ")[0]
        : "";
      const hdInvalidateDateStr = hdInvalidateDate
        ? hdInvalidateDate.split(" ")[0]
        : "";
      if (this.ruleForm.endTime && this.ruleForm.startTime) {
        // 更换组件后需要更换时间计算方法
        this.timeDay = Math.floor(
          Math.abs(
            new Date(this.ruleForm.endTime) - new Date(this.ruleForm.startTime)
          ) /
            1000 /
            60 /
            60 /
            24
        );

        //计算小时
        date3 =
          new Date(this.ruleForm.endTime).getTime() -
          new Date(this.ruleForm.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (end < nowTime) {
        this.$message.warning("活动结束时间不能小于当前时间！");
      }
      if (end < start) {
        this.$message.warning("活动开始时间不能大于结束时间！");
        return;
      }
      if (end > CRMtime && this.venderType && CRMtime && end) {
        this.$message.warning("活动有效期不可超过【云短信CRM】订购有效期。");
        this.ruleForm.endTime = "";
        return;
      }
      if (end > platformInvalidateDateValue) {
        this.$message.warning(
          `活动时间不可超过店铺接入有效期${platformInvalidateDateStr}，请重新设置！`
        );
        this.ruleForm.endTime = "";
        this.timeDay = 0;
        this.timeOut = 0;
        return;
      }
      if (end > hdInvalidateDateValue) {
        this.$message.warning(
          `活动时间不可超过互动数据授权有效期${hdInvalidateDateStr}，请重新设置！`
        );
        this.ruleForm.endTime = "";
        this.timeDay = 0;
        this.timeOut = 0;
        return;
      }
    },

    // 是否自营
    publicOpen() {
      publicOpen().then((res) => {
        if (res.message) {
          var data1 = new Date(res.message);
          var data2 = new Date();
          this.jdCrm.endTime = res.message;
          if (data1.getTime() > data2.getTime()) {
            this.jdCrm.isCrm = true;
          } else {
            this.jdCrm.isCrm = false;
          }
        }
      });
    },
    toCreated(uitype, templateId = 0) {
      this.localStepNum = 0;
      this.templateJson.templateUItype = uitype;
      if (templateId) {
        this.templateId = templateId;
      }
      if (!this.valueRow && this.isFirstTime) {
        this.isFirstTime = false;
        this.setTime();
        this.activityTimeChange();
      }
    },
    toCRM() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch",
        "_blank"
      );
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.ruleForm.exposureSwitch = false;
      this.selectGoodsStateFilter = false;
      this.localStepNum = 0;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    // 重置颜色
    resetColor() {
      this.ruleForm.textColor = defaultTextColor;
    },
    // 获取时间
    getAllTime(date) {
      const time = new Date(date);
      let yy = time.getFullYear(); //当前年份
      let mm =
        time.getMonth() + 1 < 10
          ? "0" + (time.getMonth() + 1)
          : time.getMonth() + 1;
      let dd = time.getDate() < 10 ? "0" + time.getDate() : time.getDate(); //当前天数
      return `${yy}-${mm}-${dd} ${time.getHours()}:${time.getMinutes()}:${time.getSeconds()}`;
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.titleBox) {
  margin: 16px 0;
}
.rule_box {
  width: 860px;
  background: #fafafa;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;
  &_top {
    margin: 15px 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
    .middle-box {
      display: flex;
      align-items: center;
      &_tip {
        color: #ff0000;
      }
    }
  }
  &_bottom {
    margin-left: 7px;
  }
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .firststep {
    min-height: 720px;
    box-sizing: border-box;
    padding: 0px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          &:hover {
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    .zd {
      width: 360px;
    }
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .limit {
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &:nth-child(2) {
          margin: 16px 0;
        }
      }
      .c {
        color: #fe4d45;
      }
      .desc {
        i {
          opacity: 0.7;
          color: #fe4d45;
        }
        color: #999;
      }
      /deep/ .el-input {
        margin: 0 6px;
      }
    }
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }
    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 13px 30px;
      background: #fffaee;
      font-size: 13px;
      color: #333;
      i {
        color: #fe8f8a;
        opacity: 0.7;
      }
      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }
    .generate {
      width: 76px;
      margin-top: 8px;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
    }
    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;
      p {
        margin: 0;
      }
      .add {
        margin-left: 4px;
        color: #fe4d45;
      }
    }
    .set {
      display: inline-block;
      margin-top: 30px;
    }
    .desc {
      margin-left: 20px;
      color: #999;
      font-size: 13px;
      i {
        color: #fe8f8a;
        opacity: 0.7;
        font-size: 13px;
      }
    }
    .s {
      color: #2768ff;
      cursor: pointer;
    }
    .rule-tip {
      margin-top: 8px;
    }
    .act-tip {
      white-space: nowrap;
      color: #ff0000;
    }
    /deep/ .el-table .el-table__header-wrapper th {
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
    /deep/ .el-table--enable-row-transition .el-table__body td {
      text-align: center;
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
  }
}
.miniAppPic {
  position: relative;
  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i {
      font-size: 30px;
      color: #909399;
    }
  }
  .top {
    position: relative;
    left: 8px;
    display: flex;
    .returnBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #fe4d45;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid #fe4d45;
      &:hover {
        color: #fff;
        background: #fe4d45;
      }
    }
    .reset {
      color: #fe4d45;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom {
    position: relative;
    top: 15px;
    margin-left: 115px;
    .elImg {
      width: 120px;
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1 {
      position: absolute;
      left: 135px;
      top: 22px;
      line-height: 2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
  .support {
    display: flex;
    align-items: center;
    &-text {
      margin: 0px 8px;
    }
    &-icon {
      color: #ccc;
      cursor: pointer;
    }
  }
}

.input-w425 {
  width: 425px;
}

.label {
  &-right {
    margin-right: 8px;
  }
  &-left {
    margin-left: 8px;
  }
}

.el-icon-question {
  color: #ccc;
  cursor: pointer;
}

.flex-center {
  display: flex;
  align-items: center;
}

.el-textarea {
  /deep/ .el-input__count {
    padding: 0px 5px;
    line-height: normal;
  }
}

.rule-set-box {
  background: #f8f9fc;
  padding: 20px 20px 20px 0;
  border-radius: 4px;
}
.mr-bt-12 {
  margin-bottom: 12px;
}
.mr-r-6 {
  margin-right: 6px;
}
.greyBg-box {
  // background: #f8f9fc;
  width: fit-content;
  // margin-left: 124px;
  min-width: 1007px;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 16px;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.collapse-title {
  display: flex;
  justify-content: space-between;
  width: 100%;
  // background: #f8f9fc;
  &-content {
    font-size: 16px;
    font-weight: bold;
    padding: 0 20px;
  }
}
/deep/ .el-collapse {
  border: none !important;
}
/deep/ .el-collapse-item__wrap {
  border: none !important;
}
/deep/ .el-collapse-item__content {
  padding: 0;
}
/deep/ .el-collapse-item__arrow {
  margin: 4px 4px 4px 12px;
}
/deep/ .el-collapse-item__header {
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #fafafa;
  border-bottom: none !important;
  position: relative;
  z-index: 10;
}
.ml-20 {
  margin-left: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.w320 {
  width: 320px;
}
.check-conditon-box {
  width: 580px;
  // background: #f8f9fc;
  border: 2px solid #f8f9fc;
  padding: 20px 20px 5px 20px;
  border-radius: 4px;
}
.margin-right-8 {
  margin-right: 8px;
}
.active-tip {
  color: #f89f39;
}
.margin-left-6 {
  margin-left: 6px;
}
</style>
<style lang="scss">
.createPlayStep {
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
</style>
